import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { WebServiceService } from '../../shared/services/web-service.service';
import { ToasterService } from 'angular2-toaster';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { EesDesService } from '../../shared/services/ees-des.service';
import { DataService } from '../../shared/services/data-sharing/data.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  topProduct: any = {data:[],lineChartColors:[],labels:[]}
  filteredRankingData: any = [];

  public barChartType: any = 'bar';
  public pieeChartType: any = 'pie';

  public stackbarChartType: any = 'bar';
  public stackChartType: any = 'bar';
  public stackbarlineChartType: any = 'bar';
  public vertical_title: any;
  public stackbarupdownChartType: any = 'bar';
  public barArrowChartType: any = 'bar';
  public linebarChartType: any = 'bar';
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  showTyaSuiteLogo: boolean = false;
  isRunning: boolean = false;
  isRun: boolean = false;
  isDataVisible: boolean = false;
  vendorranking: any;
  topProducts: any;
  tallyIntegrationData: any;
  failedIntegrationData: any;
  constructor(public webService: WebServiceService,
    private toasterService: ToasterService,
    private router: Router,public eesdesService:EesDesService,
    public _localStorageService: LocalStorageService, private titleService: Title, private popupService: DataService) { }
    @Output()
    makeVisibility = new EventEmitter()
    breadCrumb: string[] = [];
  dashboardData: any = [];
  dashboardLoader: boolean = false;
  clientList: any = [];
  isClient: boolean = false;
  whenNeeded:boolean = false;
  barChartLegend: boolean = true;
  pieChartLegend: boolean = true;
  pieeChartLegend: boolean = true;
  stackbarChartLegend: boolean = true;
  stackbarlineChartLegend: boolean = true;
  stackbarupdownChartLegend: boolean = true;
  stackChartLegend: boolean = true;
  linebarChartLegend: boolean = true;
  barlineChartLegend: boolean = true;
  demoBarChartList:any=[];
  lineChartList:any=[];
  linebarChartList:any=[];
  pieChartList:any=[];
  pieeChartList:any=[];
  stackbarChartList:any=[];
  stackChartList:any=[];
  stackbarlineChartList:any=[];
  barArrowChartList:any=[];
  stackbarupdownChartList:any=[];
  company_setup: any = {};
  pieChartColors:any=[];
  showPendingInvoicesPopup: boolean = false;
  inventory_title:any='Amount Rupees';
  fast_moving_title:any='Amount In Rupees/(Percentage)';
  Slow_moving_title:any='Amount In Rupees/(Percentage)';
  bank_balance_title:any='Total Amount Rs 1,77,368/-';
  loan_balance_title:any='Total Amount Rs 2,12,150/-';
  upcoming_title:any='Amount in Rupees';
  receivables_title:any='Amount in Rupees';
  net_cash_flow_title:any='Amount in Rupees';
  Customer_ageing_title:any='Amount in Rupees/(percentage';
  business_performance_title:any='Amount in Rupees/(percentage';
  po_statics_title:any='PO Statics';
  pendingPOTitle:any='Pending PO For Last Days'
  pendingPOChartType:any='bar';
  pendingPOChartLabels:any=[];
  pendingPOChartRecord:any=[];
  pendingPOChartColors:any=[];
  pendingTaskList: any = [{
    id: 0,
    text: "My PR For Approval",
    count: 15,
    color: "#4cb2c4"
  }, {
    id: 1,
    text: "Po For Approval",
    count: 30,
    color: "#4caf62"
  }, {
    id: 2,
    text: "Invoice For Approval",
    count: 10,
    color: "#f1894f"
  }, {
    id: 3,
    text: "Master For My Approval",
    count: 5,
    color: "#4eb1c2"
  }, {
    id: 4,
    text: "Payments For My Approval",
    count: 25,
    color: "#ec343c"
  }, {
    id: 5,
    text: "Payments For My Approval",
    count: 15,
    color: "#4caf62"
  },]
  pieChartType: any = 'pie';
  // pieeChartType: any = 'pie';
  chartList: any = [];
  // company_setup:any = {};
  today:Date= new Date()
  curHr:any= this.today.getHours()
  message:any='';
  userCode: any = "";
  userName: string = '';
  employeeUserRoleId:any = localStorage.getItem('emp_role') ? localStorage.getItem('emp_role') : ''
  // complianceCardList:any=[
  //   {'client_name':'abc',"label":['Pending','Upcoming','Over-Due','Completed'],"data":[10,20,0,90],"pieChartType":'pie',"lineChartLegend":true}
  // ];
  isMultiple:boolean=false;
  showSupportPopupFlag = false;

  ngOnInit() {
    window.sessionStorage.clear()
    this.isMultiple = this.eesdesService.get('isMultiple',localStorage.getItem('isMultiple')) == '1' ? true : false;
   this.employeeUserRoleId = localStorage.getItem('emp_role') ? localStorage.getItem('emp_role') : ''
this.getMenuList();
    this.checkAuth();
    this.makeChartList();
    this.barchartDemo();
    this.titleService.setTitle("Dashboard");
    document.getElementById("base-div").style.paddingTop = "65px";
    document.getElementById("base-div").style.marginLeft = "60px";
    document.getElementById("mySidenav").style.width = "60px";
    document.getElementById("header").style.display = "block";
    localStorage.removeItem('pm_dashboard_action');
    localStorage.removeItem('master_dashboard_action');
    localStorage.removeItem('report_dashboard_action')
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
   this.popupService.popupState$.pipe(takeUntil(this.destroy$)).subscribe(show => {
    if(show){
      this.showSupportPopupFlag = show;
    }else{
      this.showSupportPopupFlag = false;
    }
  });
  }

  private isDashboardActive(): boolean {
    return !this.destroy$.closed;
  }

  private dashboardApi(url: string, data: any) {
    return this.webService.commonPostMethod(url, data).pipe(takeUntil(this.destroy$));
  }

  private dashboardCounterLoadStarted = false;
  private dashboardCounterHttpBusy = false;
  private dashboardCounterHttpQueue: Array<() => void> = [];

  private beginDashboardCounterLoad() {
    this.dashboardCounterLoadStarted = true;
    this.dashboardCounterHttpBusy = false;
    this.dashboardCounterHttpQueue = [];
  }

  private resetDashboardCounterLoad() {
    this.dashboardCounterLoadStarted = false;
    this.dashboardCounterHttpBusy = false;
    this.dashboardCounterHttpQueue = [];
  }

  private enqueueDashboardCounterHttp(execute: () => void) {
    this.dashboardCounterHttpQueue.push(execute);
    this.pumpDashboardCounterHttpQueue();
  }

  private pumpDashboardCounterHttpQueue() {
    if (this.dashboardCounterHttpBusy || this.dashboardCounterHttpQueue.length === 0 || !this.isDashboardActive()) {
      return;
    }
    const execute = this.dashboardCounterHttpQueue.shift();
    if (!execute) {
      return;
    }
    this.dashboardCounterHttpBusy = true;
    execute();
  }

  private releaseDashboardCounterHttpSlot() {
    this.dashboardCounterHttpBusy = false;
    this.pumpDashboardCounterHttpQueue();
  }

  /** One counter HTTP at a time when afterComplete is provided (dashboard initial load chain). */
  private runDashboardCounterHttp(
    url: string,
    data: any,
    afterComplete: (() => void) | undefined,
    next: (data: any) => void,
    error?: () => void
  ) {
    const executeRequest = () => {
      this.dashboardApi(url, data).pipe(
        finalize(() => {
          if (afterComplete !== undefined) {
            this.releaseDashboardCounterHttpSlot();
            afterComplete();
          }
        })
      ).subscribe(
        next,
        () => {
          if (error) {
            error();
          }
        }
      );
    };

    if (afterComplete !== undefined) {
      this.enqueueDashboardCounterHttp(executeRequest);
    } else {
      executeRequest();
    }
  }

  private continueDashboardCounterChain(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (onComplete) {
      onComplete();
    }
  }

  private proceedDashboardCounterNext(onComplete: (() => void) | undefined, legacyNext: () => void) {
    if (onComplete) {
      this.continueDashboardCounterChain(onComplete);
    } else {
      legacyNext();
    }
  }

  /** Load renderBreadcrum counter APIs one at a time to reduce backend contention. */
  private loadDashboardCounterApisSequentially() {
    if (!this.isDashboardActive()) {
      return;
    }
    this.beginDashboardCounterLoad();
    this.getPendingPMTask(() => {
      this.getPendingTaskForVendor(() => {
        this.getVendorPOStatics(() => {
          this.getVendorInvoiceStatics(() => {
            this.getVendorPOBarStatics(() => {
              this.getTallyIntegrationData(() => {
                this.getMyAmcTaskCards(() => {
                  this.getAllAmcTaskCards(() => {
                    if (this.company_setup.hide_dashboard_counter == '0') {
                      this.getAmcOverdueAgeingChart('my', () => {
                        this.getAmcOverdueAgeingChart('all', () => {
                          this.getFailedIntegrationData(() => {
                            this.loadDashboardMainCounterChainSequentially();
                          });
                        });
                      });
                    } else {
                      this.getFailedIntegrationData(() => {
                        this.loadDashboardMainCounterChainSequentially();
                      });
                    }
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  /** Main dashboard counter chain — runs after renderBreadcrum counters, one API at a time. */
  private loadDashboardMainCounterChainSequentially() {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this.company_setup.hide_dashboard_counter == '1') {
      return;
    }
    this.getClientList(() => {
      this.getDynamicData(() => {
        this.getDynamicProjectData(() => {
          this.getPendingTaskForRaiser(() => {
            this.getPendingPMTaskForRaiser(() => {
              this.getPendingTask(() => {
                this.getCardData(() => {
                  this.getInvoiceAgeingData();
                });
              });
            });
          });
        });
      });
    });
  }
  barChartLabelsList:any=[];
  ChartLabelsList:any=[];
  ChartbarlineLabelsList:any=[];
  pieChartLabelsList:any=[];
  pieeChartLabelsList:any=[];
  ChartLegend:any=[];
  stackbarChartLabelsList:any=[];
  stackChartLabelsList:any=[];
  stackbarlineChartLabelsList:any=[];
  stackbarupdownChartLabelsList:any=[];
  barArrowLabelsList:any=[];
  barchartDemo()
  {

    //Inventory Details

    this.demoBarChartList=[];
    this.lineChartList=[];
    this.linebarChartList=[];
    this.barChartLabelsList=["Item 1","Item 2",'Item 3','Item 4','Item 5','Other Item']
    this.demoBarChartList=[
    {
      data: [15,30, 40, 50, 60,80],
       label: 'Slow Moving',
      },

  ]

//Fast Moving Items

  this.ChartLabelsList=["Item 1","Item 2",'Item 3','Item 4','Item 5','Other Item']
    this.lineChartList=[
       {
        type: 'line',
      label: "Gross Margin",
      data: [20, 50, 45, 70, 45, 50],
      fill: false,
      borderColor: 'orange',
      pointStyle: 'spline',
      pointBorderWidth: 3
    },
    {
      label: "High value",
      data: [80, 60, 50, 40, 30, 15,],
      backgroundColor: ['#FF0000','#00FA9A','#FF0000','#00FA9A','#FF0000','#00FA9A',]

      },

  ]

  //Slow Moving Items

  this.ChartbarlineLabelsList=["Item 1","Item 2",'Item 3','Item 4','Item 5','Other Item']
    this.linebarChartList=[
 {
        type: 'line',
      label: "My Second dataset",
      data: [30, 40, 70, 60, 65, 40],
      fill: false,
      borderColor: 'red',
      pointStyle: 'spline',
      pointBorderWidth: 3,
      display: true,
    },
    {
      label: "high vallue",
      data: [80,70, 60, 50, 40, 30, 20, 15],
      backgroundColor: ['	#0000cc','#33cc33','#0000cc','#33cc33','#0000cc','#33cc33',]

      },

  ]

  //Bank Balance
  this.pieChartLabelsList = ['HDFC Bank', 'Katak Bank', 'Axis Bank', 'SBI Bank', 'ICIC Bank','Other Banks'];
    this.pieChartList=[
    {
      title:"abcd",
        type: 'pie',
      // data:  [12, 10, 15, 10, 40, 13],
      data:  [10, 10, 12, 15, 40, 13],
      backgroundColor: ['#FF0000','#FF8C00','#00FA9A','	#32CD32','#FF0000','#0000CD','#FFFF00',]

    }
  ]
  this.pieeChartLabelsList = ['HDFC Bank', 'Katak Bank', 'Axis Bank', 'SBI Bank', 'ICIC Bank','Other Banks','date=maturity/Renewal Date'];
  // this.ChartLegend ={
  //   visible:true,
  //   posit

  // }
    this.pieeChartList=[
    {
      title:"abcd",
        type: 'pie',
      // data:  [12, 10, 15, 10, 40, 13],
      data:  [25, 10, 10, 5, 30, 20],
      backgroundColor: ['#ff0000','#40ff00','	#00ffbf','#ff9900','#FFFF00','#000080',, ]

    },

      // {"label":'HDFC Bank',"data":[25],text:'25%'},

  ]

  //Upcoming Payables
  this.stackbarChartLabelsList =['Next Week', '2nd Week', '3rd week', '4th week', '5th Week','later'];
  this.stackbarChartList=[
    { data: [45, 18, 32, 60, 5,10], label: 'opex', stack: 'a',
   },
    { data: [10, 17, 32, 25, 20, 40], label: 'capex', stack: 'a',
    backgroundColor: ['#32CD32','#32CD32','#32CD32','#32CD32','#32CD32','#32CD32']

  }
  ]
  //
  this.stackChartLabelsList =['Next Week', '2nd Week', '3rd week', '4th week', '5th Week','later'];
  this.stackChartList=[
    { data: [60, 20, 15, 50, 60,20], label: 'Other Customers', stack: 'a',
   },
    { data: [15, 35, 15, 20, 20, 20], label: 'Top 10 Customer By Revenue', stack: 'a',
    backgroundColor: ['#32CD32','#32CD32','#32CD32','#32CD32','#32CD32','#32CD32']

  }
  ]
  //Customer Ageing
  this.stackbarlineChartLabelsList =['Current', '1-15 Days', '16-30 Days', '31-60 Days', '61-90 Days','More than 90 Days'];
  this.stackbarlineChartList=[
    {
      type: 'line',
    label: "Percentage Of Total Receivable",
    data: [50, 60, 30, 50, 40, 70],
    fill: false,
    borderColor: 'blue',
    pointStyle: 'spline',
    pointBorderWidth: 3,
    display: true,
  },

    { data: [35, 30, 15, 15, 30,50], label: 'Others', stack: 'a',
    backgroundColor: ['#FFA500','#FFA500','#FFA500','#FFA500','#FFA500','#FFA500']
   },
    { data: [15, 30, 15, 35, 10, 20], label: 'Top 10 Customer By Revenue', stack: 'a',
    backgroundColor: ['#32CD32','#32CD32','#32CD32','#32CD32','#32CD32','#32CD32'] }
  ]

  //Upcoming Net Cash Flow
  this.stackbarupdownChartLabelsList =['Over Due', 'Next Week', '2nd Week', '3rd Week', '4th Week','5th Week','Later'];
  this.stackbarupdownChartList=[

    { data: [-20, -10, 50, 30, 100,90, -90]},

  ]


  this.barArrowLabelsList=["Jan","Feb",'Mar','Apr','May','Jun']
    this.barArrowChartList=[

      {
        type: 'line',
      label: "Net Profit Percentage",
      data: [26,49,70, 50,55, 68],
      fill: false,
      borderColor: '#00cc00',
      pointStyle: 'spline',
      pointBorderWidth: 3,
      display: true,
    },
    {
      label: "Revenue",
      data: [68,35,39, 75, 45, 50],
      backgroundColor: ['	red','red','red','red','red','red',]

      },
    {
      label: "Expense",
      data: [40,55,40, 38,65,40],
      backgroundColor: ['	#0000cc','#0000cc','#0000cc','#0000cc','#0000cc','#0000cc',]

      },
    {
      label: "Net Profit",
      data: [20,15,26,30,38,20,],
       backgroundColor: ['	#77b300','#77b300','#77b300','#77b300','#77b300','#77b300',]

      },

  ]

  }
  getGreeting()
  {
    this.userName = this._localStorageService.getUserName()
    this.userCode = "(" + this.eesdesService.get('employee_code',localStorage.getItem('employee_code')) + ")";

    if (this.company_setup.is_welcome_message_visible=='1') {

     let temp:any=[];
     temp= this.company_setup.welcome_item_columnList.options.filter((v)=>{return v.time_value>this.curHr})
    //  console.log(temp)
    //  console.log(this.curHr)

     if(temp.length>0)
      {
        // console.log(temp[0])

        this.message=temp[0].message_value+" " +this.userName;
      }
    }
  }
  isPendingCardVisible(id)
  {
    return this.company_setup.email_dashboard_notification.some((v)=>{return v.id==id && v.is_visible_on_dashboard && v.is_visible_on_dashboard_by_url})
  }
  isPendingCardVisibleForPM(id)
  {
    return this.company_setup.project_management_dashboard_notification.some((v)=>{return v.id==id && v.is_visible_on_dashboard && v.is_visible_on_dashboard_by_url})
    // return true;
  }

  isPendingCardVisibleForRaiser(id)
  {
    // Only for SRN: backend sends id with "raise_" prefix (raise_pending_srn)
    // but this function strips "raise_" from keys. So handle SRN without disturbing other ids.
    if (id == 'raise_pending_srn') {
      return this.company_setup.email_dashboard_notification.some((v)=>{
        return v.id == 'raise_pending_srn' && v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url
      })
    }
    if(id!=''&&id!=undefined)
    {
      if(id!='pending_raised_stock')
      {

      id=id.replace("raise_", "")
      }
      else
      {
        id="pending_stock_issue"
      }
    }
    // console.log("id",id)
    // console.log("this.company_setup.email_dashboard_notification",this.company_setup.email_dashboard_notification)
    const raiserMatch = (v) => v.id == id && v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url;
    if (id === 'mailed_invoice' || id === 'failed_mailed_invoice') {
      const em = this.company_setup.email_dashboard_notification || [];
      const zt = this.company_setup.zero_touch_dashboard_notifications || [];
      return em.some(raiserMatch) || zt.some(raiserMatch);
    }
    return this.company_setup.email_dashboard_notification.some(raiserMatch)
  }
  shouldShowRfqPendingForPoTitle() {
    const rfqPendingForPo = (this.company_setup.email_dashboard_notification)
    .find((v) => v.id === 'rfq_pending_for_po');
    if (!rfqPendingForPo) {
      return false;
    }
    return rfqPendingForPo.is_visible_on_dashboard === true;
  }
  isPendingPMCardVisibleForRaiser(id)
  {
    if(id!=''&&id!=undefined)
    {
      id=id.replace("raise_", "")
    }
    const pmMatch = (v) => v.id == id && v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url;
    if (id === 'mailed_invoice' || id === 'failed_mailed_invoice') {
      const pm = this.company_setup.project_management_dashboard_notification || [];
      const zt = this.company_setup.zero_touch_dashboard_notifications || [];
      return pm.some(pmMatch) || zt.some(pmMatch);
    }
    return this.company_setup.project_management_dashboard_notification.some(pmMatch)
  }
  GetCompanySetUpData() {
    if (!this.isDashboardActive()) {
      return;
    }
    let req = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      variable_list:['is_my_pending_task_visible_in_dashboard','welcome_item_columnList',
      'email_dashboard_notification','project_management_dashboard_notification',
      'vendor_dashboard_notification',
      'dashboard_cards_according_to_user_role_pm','is_vendor_po_statistics_visible',
      'is_vendor_invoice_statistics_visible','is_vendor_po_till_date_visible','landing_url',
      'is_vendor_po_not_dis_till_date_visible',"is_update_action_mand_for_incom_ven_profile","MINUTES_UNITL_AUTO_LOGOUT",'how_many_days_pending_in_dashboard','currency_icon',"hide_tyasuite_logo_in_landing_dashboard", "hide_dashboard_counter" ,"view_more_button", "enable_strict_auto_logout_policy", "enable_invoice_ageing_card_with_daywise_counts", "zero_touch_dashboard_notifications", "sap_b1_api_enable", "enable_sap_integration", "enable_all_company_data_approval", "is_risky_vendors_visible_in_dashboard"],
      component:this.constructor.name?this.constructor.name:'',

    }
    this.company_setup={}
    this.company_setup.email_dashboard_notification=[];
    this.company_setup.vendor_dashboard_notification=[];
    this.company_setup.zero_touch_dashboard_notifications=[];

    this.company_setup.project_management_dashboard_notification=[];
    this.dashboardApi("Update_company_meta/ajax_getall_bycompany_limited_as_requested", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup={}
          this.company_setup=data.response ? data.response : {}
          this.company_setup.currency_icon=this.company_setup.currency_icon?this.company_setup.currency_icon:'INR'
          this.company_setup.how_many_days_pending_in_dashboard=parseInt(this.company_setup.how_many_days_pending_in_dashboard?this.company_setup.how_many_days_pending_in_dashboard:0)

          this.pendingPOTitle="Pending Data For Last "+this.company_setup.how_many_days_pending_in_dashboard+" Days";
          this.company_setup.is_my_pending_task_visible_in_dashboard = this.company_setup.is_my_pending_task_visible_in_dashboard ? this.company_setup.is_my_pending_task_visible_in_dashboard : '0';
          this.company_setup.view_more_button = this.company_setup.view_more_button ? this.company_setup.view_more_button : '0';

          this.company_setup.welcome_item_columnList=this.company_setup.welcome_item_columnList?this.company_setup.welcome_item_columnList:{"options":[]};
          this.company_setup.email_dashboard_notification=this.company_setup.email_dashboard_notification?this.company_setup.email_dashboard_notification:[];
          this.company_setup.landing_url=this.company_setup.landing_url?this.company_setup.landing_url:'1';
          this.company_setup.hide_tyasuite_logo_in_landing_dashboard=this.company_setup.hide_tyasuite_logo_in_landing_dashboard?this.company_setup.hide_tyasuite_logo_in_landing_dashboard:'0';
          if(this.company_setup.hide_tyasuite_logo_in_landing_dashboard == '1'){
            this.showTyaSuiteLogo = false;
          }else{
            this.showTyaSuiteLogo = true;
          }
       

          if(this.company_setup.email_dashboard_notification)
          {
            for(let i of this.company_setup.email_dashboard_notification)
            {
              i.id=(i.id!='' && i.id!=undefined && i.id!=null)?(i.id.trim()):i.id
              i.raise_page_url=this.getPageUrl(i,'RAISE')
              const isMailedInvoiceCard = i.id === 'mailed_invoice' || i.id === 'failed_mailed_invoice';
              const raiserToggleOn = i.is_visible_on_raiser_dashboard === true || i.is_visible_on_raiser_dashboard === 1 || i.is_visible_on_raiser_dashboard === '1';
              if (isMailedInvoiceCard) {
                i.is_visible_on_raiser_dashboard_by_url = raiserToggleOn;
                i.is_visible_on_raiser_dashboard = raiserToggleOn;
              } else {
                i.is_visible_on_raiser_dashboard_by_url=i.is_visible_on_raiser_dashboard&&this.IS_VAILID_URL(i.raise_page_url);
                i.is_visible_on_raiser_dashboard=i.is_visible_on_raiser_dashboard_by_url
              }
              i.approve_page_url=this.getPageUrl(i,'APPROVE')
              i.is_visible_on_dashboard_by_url=i.is_visible_on_dashboard&&this.IS_VAILID_URL(i.approve_page_url);

            }
          }
          this.company_setup.zero_touch_dashboard_notifications=this.company_setup.zero_touch_dashboard_notifications?this.company_setup.zero_touch_dashboard_notifications:[];
          if(this.company_setup.zero_touch_dashboard_notifications)
          {
            for(let i of this.company_setup.zero_touch_dashboard_notifications)
            {
              i.id=(i.id!='' && i.id!=undefined && i.id!=null)?(String(i.id).trim()):i.id
              i.raise_page_url=this.getPageUrl(i,'RAISE')
              const isMailedInvoiceCard = i.id === 'mailed_invoice' || i.id === 'failed_mailed_invoice';
              const raiserToggleOn = i.is_visible_on_raiser_dashboard === true || i.is_visible_on_raiser_dashboard === 1 || i.is_visible_on_raiser_dashboard === '1';
              if (isMailedInvoiceCard) {
                i.is_visible_on_raiser_dashboard_by_url = raiserToggleOn;
                i.is_visible_on_raiser_dashboard = raiserToggleOn;
              } else {
                i.is_visible_on_raiser_dashboard_by_url=i.is_visible_on_raiser_dashboard&&this.IS_VAILID_URL(i.raise_page_url);
                i.is_visible_on_raiser_dashboard=i.is_visible_on_raiser_dashboard_by_url
              }
              i.approve_page_url=this.getPageUrl(i,'APPROVE')
              i.is_visible_on_dashboard_by_url=i.is_visible_on_dashboard&&this.IS_VAILID_URL(i.approve_page_url);
            }
          }
          // console.log(this.company_setup.email_dashboard_notification);

          if(this.company_setup.email_dashboard_notification.some((v)=>{return v.id=='recurring_invoice'}))
          {
            let d=this.company_setup.email_dashboard_notification.filter((v)=>{return v.id=='recurring_invoice'})[0]
         // this.company_setup.project_management_dashboard_notification.push(d)
          }
          if(this.company_setup.project_management_dashboard_notification)
          {
            for(let i of this.company_setup.project_management_dashboard_notification)
            {
              i.raise_page_url=this.getPMPageUrl(i,'RAISE')
              i.is_visible_on_raiser_dashboard_by_url=i.is_visible_on_raiser_dashboard&&this.IS_VAILID_URL(i.raise_page_url);
              i.is_visible_on_raiser_dashboard=i.is_visible_on_raiser_dashboard_by_url
              i.approve_page_url=this.getPMPageUrl(i,'APPROVE')
              i.is_visible_on_dashboard_by_url=i.is_visible_on_dashboard&&this.IS_VAILID_URL(i.approve_page_url);

            }
          }
          // console.log(this.company_setup.project_management_dashboard_notification);

          this.company_setup.vendor_dashboard_notification=this.company_setup.vendor_dashboard_notification?this.company_setup.vendor_dashboard_notification:[];

          this.company_setup.project_management_dashboard_notification=this.company_setup.project_management_dashboard_notification?this.company_setup.project_management_dashboard_notification:[];
          this.company_setup.is_welcome_message_visible='0'
          this.company_setup.is_my_pending_task_visible_in_dashboard= this.company_setup.email_dashboard_notification.some((v)=>{return v.is_visible_on_dashboard && v.is_visible_on_dashboard_by_url})?'1':'0'

          this.company_setup.is_my_pending_task_visible_in_dashboard_for_vendor= this.company_setup.vendor_dashboard_notification.some((v)=>{return v.is_visible_on_vendor_dashboard})?'1':'0'


          this.company_setup.is_my_pending_task_visible_in_dashboard_for_raiser= (this.company_setup.email_dashboard_notification.some((v)=>{return v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url}) || this.company_setup.zero_touch_dashboard_notifications.some((v)=>{return v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url}))?'1':'0'
          this.company_setup.is_my_pending_project_managementTask_visible_in_dashboard_for_raiser= this.company_setup.project_management_dashboard_notification.some((v)=>{return v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url})?'1':'0'
          this.company_setup.is_my_pending_project_managementTask_visible_in_dashboard= this.company_setup.project_management_dashboard_notification.some((v)=>{return v.is_visible_on_dashboard && v.is_visible_on_dashboard_by_url})?'1':'0'
          this.company_setup.dashboard_cards_according_to_user_role_pm= this.company_setup.dashboard_cards_according_to_user_role_pm ? this.company_setup.dashboard_cards_according_to_user_role_pm : []
if (this.company_setup.welcome_item_columnList.options.length>0) {
  this.company_setup.is_welcome_message_visible=this.company_setup.welcome_item_columnList.options.some((v)=>{return v.visible_value})?'1':'0';

}
          if(req.company_id=='0'||req.company_id==''||req.company_id==undefined)
          {
            this.company_setup.is_welcome_message_visible = this.company_setup.is_welcome_message_visible ? this.company_setup.is_welcome_message_visible : '1';
          }
          if(this.company_setup.is_welcome_message_visible=='1')
          {
            this.getGreeting();
          }

          this.company_setup.is_vendor_po_not_dis_till_date_visible = this.company_setup.is_vendor_po_not_dis_till_date_visible ? this.company_setup.is_vendor_po_not_dis_till_date_visible : '1';
          this.company_setup.is_vendor_po_till_date_visible = this.company_setup.is_vendor_po_till_date_visible ? this.company_setup.is_vendor_po_till_date_visible : '1';
          this.company_setup.is_vendor_invoice_statistics_visible = this.company_setup.is_vendor_invoice_statistics_visible ? this.company_setup.is_vendor_invoice_statistics_visible : '1';
          this.company_setup.is_vendor_po_statistics_visible = this.company_setup.is_vendor_po_statistics_visible ? this.company_setup.is_vendor_po_statistics_visible : '1';
          this.company_setup.is_risky_vendors_visible_in_dashboard = this.company_setup.is_risky_vendors_visible_in_dashboard ? this.company_setup.is_risky_vendors_visible_in_dashboard : '0';
          this.company_setup.hide_dashboard_counter = this.company_setup.hide_dashboard_counter ? this.company_setup.hide_dashboard_counter : '0';
          // this.company_setup.hide_dashboard_counter = "1";
          this.company_setup.MINUTES_UNITL_AUTO_LOGOUT = this.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? this.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10;
          localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',this.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
          this.company_setup.enable_strict_auto_logout_policy = this.company_setup.enable_strict_auto_logout_policy ? this.company_setup.enable_strict_auto_logout_policy : '0';
          localStorage.setItem('enable_strict_auto_logout_policy',this.company_setup.enable_strict_auto_logout_policy);
          this.company_setup.enable_invoice_ageing_card_with_daywise_counts = this.company_setup.enable_invoice_ageing_card_with_daywise_counts ? this.company_setup.enable_invoice_ageing_card_with_daywise_counts : '0';
          this.company_setup.sap_b1_api_enable = this.company_setup.sap_b1_api_enable ? this.company_setup.sap_b1_api_enable : '0';
          this.company_setup.enable_sap_integration = this.company_setup.enable_sap_integration ? this.company_setup.enable_sap_integration : '0';
          this.company_setup.enable_all_company_data_approval = this.company_setup.enable_all_company_data_approval ? this.company_setup.enable_all_company_data_approval : '0';
          this.filteredRankingData=[]
    this.topProduct.data=[]
          this.renderBreadcrum();

        }
        else {
          this.toasterService.pop('error', "Error", data.message);
          this.renderBreadcrum();
        }


      }, error => {
        this.renderBreadcrum();
        this.toasterService.pop("error", "Error", "Something Went Wrong");
      }
    )
  }
  makeChartList() {
    this.chartList = [];
    this.chartList = [
      { 'id': 'line', 'name': 'Line Chart' },
      { 'id': 'pie', 'name': 'Pie Chart' },
      { 'id': 'bar', 'name': 'Bar Chart' },
      { 'id': 'doughnut', 'name': 'Doughnut Chart' },
      { 'id': 'radar', 'name': 'Radar Chart' },
      { 'id': 'polarArea', 'name': 'Polar Area Chart' },
      { 'id': 'bubble', 'name': 'Bubble Chart' },
      { 'id': 'scatter', 'name': 'Scatter Chart' }];
  }
  urlList: any = [];
  checkAuth() {
    let page_url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let data: any = {};
    data = this.eesdesService.get('menus',localStorage.getItem('menus'))
      ? this.eesdesService.get('menus',localStorage.getItem('menus'))
      : {};

    this.urlList = data ? data : [];
    if (
      this._localStorageService.getUserId() == undefined ||
      this._localStorageService.getUserId() == null
    ) {
      this.toasterService.pop(
        'info',
        'Info',
        'You are not able access this page! Login First'
      );
      window.localStorage.clear();
      this.router.navigateByUrl('/login');


      return false;
    }
    if (
      this._localStorageService.getEmpCompanyId() == 0 ||
      this._localStorageService.getEmpCompanyId() == null ||
      this._localStorageService.getEmpCompanyId() == undefined
    ) {
    } else {
      const currenturl = page_url ? page_url : '';
      let count = 0;
      if (this.urlList.length > 0) {
        for (const i of this.urlList) {
          if (i.submenu != undefined) {
            for (const j of i.submenu) {
              if (j.aurl == currenturl) {
                count++;
              }
            }
          }
        }
        if (count <= 0) {
          // this.toasterService.pop(
          //   'info',
          //   'Info',
          //   'you are not able access this page'
          // );
          this.router.navigateByUrl('/dashboard');
          return false;
        }
      }
    }

    return true;
  }

  renderBreadcrum() {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this.dashboardCounterLoadStarted) {
      return;
    }
    this.breadCrumb = ["Home", "Dashboard",];
    // if(this.company_setup.hide_dashboard_counter!='1') {
    //   this.getDynamicData();
    //   this.getDynamicProjectData();
    //   this.getPendingTaskForRaiser();
    //   this.getPendingPMTaskForRaiser();
    //   this.getPendingTask();
    //   this.getCardData()
    // }
    
    this.loadDashboardCounterApisSequentially();
    this.getPendingPMTask();

    // this.getClientList();

    // vendor login
    // if (this._localStorageService.getUserRole() == "vendor") {
    this.getPendingTaskForVendor();
    this.getVendorPOStatics();
    this.getVendorInvoiceStatics();
    this.getVendorPOBarStatics();
    // }

    // Tally Integration cards (permission guard inside getTallyIntegrationData)
    this.getTallyIntegrationData();
    this.getMyAmcTaskCards();
    this.getAllAmcTaskCards();
    this.getVendorDetailsCard();
    if (this.company_setup.hide_dashboard_counter == '0') {
      this.getAmcOverdueAgeingChart('my');
      this.getAmcOverdueAgeingChart('all');
    }
    this.getFailedIntegrationData();
  }
  getClientList(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    const proceedAfterClientList = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getDynamicData());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };
    let obj = {
      "userid": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : "0",
    }

     if (this._localStorageService.getUserRole() != "vendor" && this.IS_VAILID_URL('/client-master')) {

    this.runDashboardCounterHttp(
      "Clientmaster/ajax_get_assigned_clients",
      obj,
      () => proceedAfterClientList(),
      (data) => {
          if (data.status) {
            this.clientList = data.response.filter((v)=>{return v.status!=='0'});
            if (this.clientList) {

              for (let i of this.clientList) {
                this.isClient = true;
                i.count = 0;
                i.count = i.compliance_count?i.compliance_count:0;
              }
            }
            else {
              this.isClient = false;
            }
            this.clientList.sort((a, b) => parseInt(b.count) - parseInt(a.count));
          }
        },
        () => {
        }
      );
     }
     else{
      proceedAfterClientList();
     }
  }
  setClient(id, name, type, count, tl, tm,data) {
    if(data.status=='0')
    {
      this.toasterService.pop('info','Info','Client Is Deleted');
      return false;
    }
    let user_type: any = "";
    if (tl) {
      user_type = "TL";
    }
    if (tm) {
      user_type = "TM";
    }
    if (count >= 0) {
      localStorage.setItem("client_id", id);
      localStorage.setItem("client_name", name);
      localStorage.setItem("client_type", type);
      localStorage.setItem("user_type", user_type);
      window.location.href=window.location.origin+'/compliance/#/client-assigned-compliances';
      // this.webService.redirectURL('/client-assigned-compliances')
    }
    else {
      localStorage.setItem("client_id", "");
      localStorage.setItem("client_name", "");
      localStorage.setItem("client_type", "");
      localStorage.setItem("user_type", "");
      this.toasterService.pop("info", "Info", "Total Compliances For ( " + name.toUpperCase() + " ) is = " + count);
      return;
    }
  }
  responseData: any = [];
  filteredData: any = [];
  filteredviewData: any = [];

  getDynamicData(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
      if (this._localStorageService.getUserRole() == "vendor") {
       this.continueDashboardCounterChain(onComplete);
       return;
     }
    this.dashboardLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }

    const proceedAfterDynamicData = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getDynamicProjectData());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "/User_Roles/ajax_dashboard_cards_sorted",
      obj,
      onComplete ? () => proceedAfterDynamicData() : undefined,
      (data) => {
          if (data.status) {
            this.responseData = data.response
            this.dashboardData = data.response;
            this.filteredData = this.filterchartData(data.response);
            // localStorage.setItem('filteredData',JSON.stringify(this.filteredData));
            // console.log(this.filteredData);
            if (this.dashboardData) {
              for (let i of this.dashboardData) {
                if (i.items) {
                  for (let j of i.items) {
                    j.icon = this.getKeyImage(j.key);
                  }
                }
              }
              this.dashboardLoader = false;
            }
          }
          this.dashboardLoader = false;
        },
        () => {
          this.dashboardLoader = false;

        }
      );
  }


  getViewData() {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
     return;
   }
  this.dashboardLoader = true
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  }
  this.isviewCompanyCardVisible =true;


  this.dashboardApi("/User_Roles/dashboardCardsCountersBasedOnCcAccess", obj).

    subscribe(
      data => {
        if (data.status) {
          this.responseData = data.response
          this.dashboardData = data.response;
          this.filteredviewData = this.filterchartViewData(data.response);
          // localStorage.setItem('filteredData',JSON.stringify(this.filteredData));
          // console.log(this.filteredData);
          if (this.dashboardData) {
            for (let i of this.dashboardData) {
              if (i.items) {
                for (let j of i.items) {
                  j.icon = this.getKeyImage(j.key);
                }
              }
            }
            this.dashboardLoader = false;
          }
        }
        this.dashboardLoader = false;
      },
      error => {
        this.dashboardLoader = false;

      }
    );
}
filterchartViewData(data: any) {
  let list: any = [];
  for (let x of data) {
    let temp = { title: "", label: [], data: [], total: 0 };
    temp.title = x.title;
    temp.total = 0;
    for (let y of x.items) {
      temp.total = temp.total + parseFloat(y.count);
      if (parseFloat(y.count) > 0) {
        temp.label.push(y.title + " (" + y.full_title + ")");
      }
      else {
        temp.label.push(y.title);

      }
      temp.data.push(y.count);
    }
    temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';

    list.push(temp);
  }
  return list;
}

  filterchartData(data: any) {
    let list: any = [];
    for (let x of data) {
      let temp = { title: "", label: [], data: [], total: 0 };
      temp.title = x.title;
      temp.total = 0;
      for (let y of x.items) {
        temp.total = temp.total + parseFloat(y.count);
        if (parseFloat(y.count) > 0) {
          temp.label.push(y.title + " (" + y.count + ")");
        }
        else {
          temp.label.push(y.title);

        }
        temp.data.push(y.count);
      }
      temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';

      list.push(temp);
    }
    return list;
  }

  getKeyImage(key) {
    let image = "";
    switch (key) {
      case "raised_pr":
        image = "Damaged@2x.png";
        break;
      case "pending_pr":
        image = "Pending@2x.png";
        break;
        case "recurring_invoice":
        image = "Pending@2x.png";
        break;

      case "rejected_pr":
        image = "Rejected@2x.png";
        break;
      case "approved_pr":
        image = "Approved@2x.png";
        break;
      case "raised_po":
        image = "Damaged@2x.png";
        break;
      case "pending_po":
        image = "Pending@2x.png";
        break;
      case "approved_po":
        image = "Approved@2x.png";
        break;
      case "rejected_po":
        image = "Rejected@2x.png";
        break;
      case "received_items":
        image = "Received@2x.png";
        break;
      case "total_items":
        image = "Damaged@2x.png";
        break;
      case "accepted_items":
        image = "Received@2x.png";
        break;
      case "rejected_items":
        image = "Rejected@2x.png";
        break;
      case "damaged_items":
        image = "Damaged@2x.png";
        break;
      case "all_invoice":
        image = "Damaged@2x.png";
        break;
      case "pending_iv":
        image = "Pending@2x.png";
        break;
      case "approved_iv":
        image = "Approved@2x.png";
        break;
      case "rejected_iv":
        image = "Rejected@2x.png";
        break;
      case "all_invoice_payment":
        image = "Damaged@2x.png";
        break;
      case "pending_ip":
        image = "Pending@2x.png";
        break;
      case "approved_ip":
        image = "Approved@2x.png";
        break;
      case "rejected_ip":
        image = "Rejected@2x.png";
        break;
      default:
        image = "#";
    }
    return image;
  }
  navigateUrl(key, module, count, title) {
    if (count <= 0) {
      this.toasterService.pop("info", "Info", title + " = " + count);
      return false;
    }
    let url = "";
    let dashboardAction = ""
    switch (key) {
      case "raised_pr":
        url = "my-purchases-pr";
        dashboardAction = ""
        break;

      case "pending_pr1":
        url = "my-purchases-pr";
        dashboardAction = "pending_pr"
        break;
        case "recurring_invoice":
          url = "auto-generated-inv";
          dashboardAction = "pending_recurring_invoice"
          break;
      case "rejected_pr":
        url = "my-purchases-pr";
        dashboardAction = "rejected_pr"
        break;
      case "approved_pr":
        url = "my-purchases-pr";
        dashboardAction = "approved_pr"
        break;
      case "raised_po":
        url = "my-orders";
        dashboardAction = ""
        break;
      case "pending_po":
        url = "my-orders";
        dashboardAction = "pending_po"
        break;
      case "approved_po":
        url = "my-orders";
        dashboardAction = "approved_po"
        break;
      case "rejected_po":
        url = "my-orders";
        dashboardAction = "rejected_po"
        break;
      case "received_items":
        url = "#";
        dashboardAction = "received_items"
        break;
      case "total_items":
        url = "#";
        dashboardAction = ""
        break;
      case "accepted_items":
        url = "#";
        dashboardAction = "accepted_items"
        break;
      case "rejected_items":
        url = "#";
        dashboardAction = "rejected_items"
        break;
      case "damaged_items":
        url = "#";
        dashboardAction = "damaged_items"
        break;
      case "damaged_items":
        url = "#";
        dashboardAction = "damaged_items"
        break;
      case "all_invoice":
        url = "invoice-report";
        dashboardAction = ""
        break;
      case "pending_iv":
        url = "invoice-report";
        dashboardAction = "pending_iv"
        break;
      case "approved_iv":
        url = "invoice-report";
        dashboardAction = "approved_iv"
        break;
      case "rejected_iv":
        url = "invoice-report";
        dashboardAction = "rejected_iv"
        break;
      case "all_invoice_payment":
        url = "my-invoices";
        dashboardAction = ""
        break;
      case "pending_ip":
        url = "my-invoices";
        dashboardAction = "pending_ip"
        break;
      case "approved_ip":
        url = "my-invoices";
        dashboardAction = "approved_ip"
        break;
      case "rejected_ip":
        url = "my-invoices";
        dashboardAction = "rejected_ip"
        break;
      default:
        url = "#";
    }
    localStorage.setItem("dashboardAction", this.webService.set(dashboardAction,'dashboardAction'));
    this.webService.redirectURL(url)

  }
  getkeyName(id,name)
  {
    let t:any='';
    t=Object.keys(id);


    if(t==name)
    {
      return true;
    }
    return false;
  }
  responseProjectData: any = [];
  filteredProjectData: any = [];
  dashboardProjectLoader: boolean = false;
  invoiceAgeingData: any = null;
  invoiceAgeingLoader: boolean = false;
  getDynamicProjectData(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
      if (this._localStorageService.getUserRole() == "vendor") {
       this.continueDashboardCounterChain(onComplete);
       return;
     }
     if(!this.IS_VAILID_URL('/my-project-master')&&!this.IS_VAILID_URL('/project-master')&&!this.IS_VAILID_URL('/project-master-approval'))
    {
      if(this.company_setup.hide_dashboard_counter!='1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getPendingTaskForRaiser());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
      return;
    }

    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }

    const proceedAfterProjectData = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getPendingTaskForRaiser());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "project/Project_master/get_all_projects_for_chart",
      obj,
      onComplete ? () => proceedAfterProjectData() : undefined,
      (data) => {
          if (data.status) {
            this.responseProjectData = data.response?data.response:[]

            if(!Array.isArray(this.responseProjectData))
            {
              return;
            }

            this.filteredProjectData = this.filterchartProjectData(this.responseProjectData);
            if (data.response) {
              for (let i of data.response) {
                if (i.items) {
                  for (let j of i.items) {
                    j.icon = this.getKeyImage(j.key);
                  }
                }
              }
              this.dashboardProjectLoader = false;
            }

          }
          this.dashboardProjectLoader = false;
        },
        () => {
          this.dashboardProjectLoader = false;

        }
      );

  }
  getInvoiceAgeingData(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.invoiceAgeingLoader = true;
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }
    this.runDashboardCounterHttp(
      "ocr/Api/invoiceAgeingCounters",
      obj,
      onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
      (data) => {
          this.invoiceAgeingLoader = false;
          if (data.status && data.data && data.data.ageing_buckets) {
            this.invoiceAgeingData = this.formatInvoiceAgeingData(data.data);
          }
        },
        () => {
          this.invoiceAgeingLoader = false;
        }
      );
  }

  formatInvoiceAgeingData(data: any) {
    let totalCount = data.summary ? data.summary.total_count : 0;
    const ageingBucketColors: { [bucketName: string]: string } = {
      '0 Day': '#59A14F',
      '1 Day': '#4E79A7',
      '2 Days': '#F28E2B',
      '3 Days': '#E15759',
      '4 Days': '#76B7B2',
      '5 Days': '#EDC949',
      '6 Days': '#AF7AA1',
      '7 Days': '#9C755F',
      '7-15 Days': '#FF7C43',
      'More than 15 Days': '#A05195',
      '15+': '#A05195'
    };
    const defaultAgeingColor = '#4E79A7';
    let temp = {
      title: "Unprocessed Invoice Ageing (" + totalCount + ")",
      label: [],
      data: [],
      colors: [],
      total: totalCount,
      pieChartType: 'pie',
      lineChartLegend: true,
      key: 'invoice_ageing',
      items: []
    };
    if (data.ageing_buckets && Array.isArray(data.ageing_buckets)) {
      for (let bucket of data.ageing_buckets) {
        let count = bucket.count || 0;
        if (count > 0) {
          let labelText = bucket.bucket + " (" + count + ")";
          temp.label.push(labelText);
          temp.data.push(count);
          temp.colors.push(ageingBucketColors[bucket.bucket] || defaultAgeingColor);
          temp.items.push({
            bucket: bucket.bucket,
            count: count,
            value: bucket.value,
            from_date: bucket.from_date,
            to_date: bucket.to_date,
            days_range: bucket.days_range,
            label: labelText
          });
        }
      }
    }
    temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';
    return temp;
  }

  filterchartProjectData(data: any) {
    let list: any = [];
    for (let x of data) {
      let temp = { title: "", label: [], data: [], total: 0, pieChartType: 'pie', lineChartLegend: true , key:x.key};
      temp.title = x.title;
      temp.pieChartType = temp.pieChartType ? temp.pieChartType : 'pie';
      temp.total = 0;
      for (let y of x.items) {
        temp.total = temp.total + parseFloat(y.count);
        if (parseFloat(y.count) > 0) {
          temp.label.push(y.title + " (" + y.count + ")");
        }
        else {
          //temp.label.push(y.title);
          temp.label.push(y.title + " (0)");

        }
        temp.data.push(y.count);
      }
      temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';

      list.push(temp);
    }
    return list;
  }
  getData(d)
  {

  }
  pendingTaskTitle:any='';
  pendingTaskCount:any = 0;
  getPendingTask(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }

    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingTaskCount = "";
    let localCount:any = 0;
    this.pendingTaskList=[];
// if(this.company_setup.email_dashboard_notification.every((v)=>{return !v.is_visible_on_dashboard}))
// {
//   return;
// }
    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }

    const proceedAfterPendingTask = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getCardData());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "User_Roles/ajax_dashboard_pending_cards_sorted",
      obj,
      onComplete ? () => proceedAfterPendingTask() : undefined,
      (data) => {
          // console.log(data)
          if (data.status) {
            this.pendingTaskList=data.response.items?data.response.items:[];
            this.pendingTaskTitle=data.response.title?data.response.title:'';
            if(this.pendingTaskList){
              for(let totalCount of this.pendingTaskList) {
                totalCount.count = this.webService.convertNaN(totalCount.count) ? this.webService.convertNaN(totalCount.count) : 0;
                if( totalCount.count !=""){
                  if(this.isPendingCardVisible(totalCount.key)){
                    localCount += parseFloat(totalCount.count);
                  }
                }
              }
            }
            this.pendingTaskCount = localCount ? localCount : 0;
           }
           this.dashboardProjectLoader=false;
        },
        () => {
          this.dashboardProjectLoader=false;
        }
      );
  }
  pendingTaskTitleForRaiser:any='';
  pendingTaskListForRaiser:any=[];
  pendingTaskCountForRaiser:any=0;
  getPendingTaskForRaiser(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }

     if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingTaskListForRaiser=[];

//     if(this.company_setup.email_dashboard_notification.every((v)=>{return !v.is_visible_on_raiser_dashboard}))
// {
//   return;
// }
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }
    let localCount:any = 0;
    // if(1==1) {
    //   return false;
    // }
    this.dashboardProjectLoader = true

    const proceedAfterPendingTaskForRaiser = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getPendingPMTaskForRaiser());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "User_Roles/ajax_dashboard_pending_cards_sorted_for_raiser",
      obj,
      onComplete ? () => proceedAfterPendingTaskForRaiser() : undefined,
      (data) => {
          if (data.status) {
            this.pendingTaskListForRaiser=data.response.items?data.response.items:[];
            if( this.pendingTaskListForRaiser)
            {
              for(let i of  this.pendingTaskListForRaiser)
              {
                i.key=i.key=='raise_pending_recurring_invoices'?'recurring_invoices':i.key
                // if(i.key == "amc_due_for_renewal")
                // {
                //   i.key = "amc_due_for_renewal";
                // }
                i.count = this.webService.convertNaN(i.count) ? this.webService.convertNaN(i.count) : 0;

                i.count=parseInt(i.count)?parseInt(i.count):0
                i.count = i.count ? i.count : 0;
                if( i.count !=""){
                  if(this.isPendingCardVisibleForRaiser(i.key)){
                    localCount += parseFloat(i.count);
                  }
                }
              }
            }
            this.pendingTaskTitleForRaiser=data.response.title?data.response.title:''
            this.pendingTaskCountForRaiser = localCount ? localCount : 0;

           }
           this.dashboardProjectLoader=false;
        },
        () => {
          this.dashboardProjectLoader=false;

        }
      );
  }


  pendingPMTaskTitle:any='';
  pendingProjectManagementTaskList:any= [];
  pendingPMTaskCount:any = 0;
  pendingPMTaskCountLastDays:any=0;
  getPendingPMTask(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingProjectManagementTaskList=[];

//     if(!this.IS_VAILID_URL('/time-sheet-weekly')&&!this.IS_VAILID_URL('/time-sheet-v2'))
//     {
// return;
//     }
    this.pendingTaskCount = "";
    let localCount:any = 0;
    let localDaysCount:any=0;
    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
      "how_many_days_pending_in_dashboard":this.company_setup.how_many_days_pending_in_dashboard?this.company_setup.how_many_days_pending_in_dashboard:'5'
    }
    this.pendingProjectManagementTaskList=[];
    this.pendingPOChartRecord=[];
    this.pendingPOChartLabels=[];
    this.pendingPOChartColors=[]
    this.runDashboardCounterHttp(
      "project/Timesheet/get_timesheet_chart",
      obj,
      onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
      (data) => {
          if (data.status) {
            let temp:any=[];
            // data.response=typeof data.response=='object'?([data.response?data.response:{}]):data.response
            if(data.response)
            {
              for(let i of data.response)
              {
                // console.log(i)
                if(i.items.length>0)
                {
                  for(let j of i.items)
                  {
                    j.key=j.key=='raise_pending_recurring_invoices'?'recurring_invoice':j.key
                    temp.push(j);
                  }
                }
              }
            }
            this.pendingProjectManagementTaskList=temp?temp:[];
            this.pendingPMTaskTitle=data.response.title?data.response.title:'';
            let pendingPOChartRecord:any=[];
            let pendingPOChartColors:any=[];
            if(this.pendingProjectManagementTaskList){
              for(let totalCount of this.pendingProjectManagementTaskList) {
                // console.log(totalCount)
                let title=totalCount.title;
                if(title.indexOf(" For My Approval")!==-1)
                {
                  title=title.replace(" For My Approval", "");;
                }
                if(title.indexOf(" for My Approval")!==-1)
                {
                  title=title.replace(" for My Approval", "");;
                }

                totalCount.total_count = this.webService.convertNaN(totalCount.total_count) ? parseInt(this.webService.convertNaN(totalCount.total_count)) : 0;
                totalCount.count = this.webService.convertNaN(totalCount.count) ? parseInt(this.webService.convertNaN(totalCount.count)) : 0;

                if(parseInt(totalCount.total_count)>0)
                {
                this.pendingPOChartLabels.push(title)
                pendingPOChartColors.push(totalCount.color)
                pendingPOChartRecord.push(parseInt(totalCount.total_count));
                }
                if( totalCount.total_count !=""){
                  if(this.isPendingCardVisibleForPM(totalCount.key)||this.isPendingCardVisible(totalCount.key)){
                    localCount += parseFloat(totalCount.total_count);
                  }
                }
                if( totalCount.count !=""){
                  if(this.isPendingCardVisibleForPM(totalCount.key)||this.isPendingCardVisible(totalCount.key)){
                    localDaysCount += parseFloat(totalCount.count);
                  }
                }
              }
            }
            this.pendingPOChartColors.push({backgroundColor:pendingPOChartColors})
            this.pendingPOChartRecord.push({data:pendingPOChartRecord,label:'Pending',backgroundColor:pendingPOChartColors,borderWidth: 4,
            hoverBorderColor: this.companyThemeBlockColor,})
           // this.setChartType(this.pendingPOChartType);

            // this.pendingPOChartRecord=this.pendingProjectManagementTaskList?this.pendingProjectManagementTaskList:[]
            this.pendingPMTaskCount = localCount ? localCount : 0;
            this.pendingPMTaskCountLastDays= localDaysCount ? localDaysCount : 0;
            // if(this.company_setup.hide_dashboard_counter=='1') {
              this.dashboardProjectLoader = false
            // }
           }

        },
        () => {
          this.dashboardProjectLoader = false;
        }
      );
  }
  pendingPMTaskTitleForRaiser:any='';
  pendingProjectManagementTaskListForRaiser:any= [];
  pendingPMTaskCountForRaiser:any = 0;
  getPendingPMTaskForRaiser(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingProjectManagementTaskListForRaiser=[];
//     if(!this.IS_VAILID_URL('/my-project-master')&&!this.IS_VAILID_URL('/project-master')&&!this.IS_VAILID_URL('/project-master-approval'))
//     {
// return;
//     }
    this.pendingTaskCount = "";
    let localCount:any = 0;
    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }
    // if(1==1) {
    //   return false;
    // }
    this.pendingProjectManagementTaskListForRaiser=[];

    const proceedAfterPendingPMTaskForRaiser = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getPendingTask());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "project/Expense_sheet/get_pending_project_management_dashboard_chart",
      obj,
      onComplete ? () => proceedAfterPendingPMTaskForRaiser() : undefined,
      (data) => {
          if (data.status) {
            let temp :any =[];
            if(data.response){
              for(let i of data.response)
              {
                for(let j of i.items)
                {
                  j.key=j.key=='raise_pending_recurring_invoices'?'recurring_invoice':j.key
                  temp.push(j);
                }
              }
            }

            this.pendingProjectManagementTaskListForRaiser=temp?temp:[];
            this.pendingPMTaskTitleForRaiser=data.response.title?data.response.title:'';
            if(this.pendingProjectManagementTaskListForRaiser){
              for(let totalCount of this.pendingProjectManagementTaskListForRaiser) {
                if (totalCount.key == 'all_approved_rfq_response' && this.shouldShowRfqPendingForPoTitle()) {
                  totalCount.title = 'RFQ Pending for PO';
                }
                totalCount.count = this.webService.convertNaN(totalCount.count) ? this.webService.convertNaN(totalCount.count) : 0;
                if( totalCount.count !=""){
                  if(this.isPendingPMCardVisibleForRaiser(totalCount.key) || this.isPendingCardVisibleForRaiser(totalCount.key)){
                    localCount += parseFloat(totalCount.count);
                  }
                }
              }
            }
            this.pendingPMTaskCountForRaiser = localCount ? localCount : 0;
           }
        },
        () => {

        }
      );
  }

  navigatePendingPmTaskByUrl(key,isTotal) {
    let url = "";
    let project = '';
    let dashboardAction = "";
    switch (key) {
      case "pending_timesheet":
        project = 'project_management'
        dashboardAction = ""
       window.location.href=window.location.origin+'/project_management/#/time-sheet-approval';

        break;

        case "pending_project":
          project = 'project_management'
          dashboardAction = ""
          window.location.href=window.location.origin+'/project_management/#/project-master-approval';

           break;

           case "pending_questionnaire":
            project = 'master'
            dashboardAction = ""
        window.location.href=window.location.origin+'/master/#/questionnaire-for-my-approval';

          break;

          case "pending_vendor_rating":
            project = 'master'
            dashboardAction = ""
        window.location.href=window.location.origin+'/master/#/rate-vendor';

          break;

        case "pending_expense":
          project = 'project_management'
          dashboardAction = ""
      window.location.href=window.location.origin+'/project_management/#/expense-sheet-v2-approval';

        break;
        
        case "pending_task":
          project = 'project_management'
        dashboardAction = ""
       window.location.href=window.location.origin+'/project_management/#/task-master-approval';

        break;
        case "pending_pr":
          url = "/allpr-approvals";
          project='operation'
          dashboardAction = "approval_pending_pr"
          break;

        case "recurring_invoice":
          url = "/auto-generated-inv";
          project='operation'
          dashboardAction = "pending_recurring_invoice"
          if(isTotal=='1')
          {
            url = "/recurring-inv-for-approval";
            project='operation'
            dashboardAction = "approval_recurring_invoice"
          }
          break;
          case "my_pr":
            url = "/my-purchases-pr";
            project='operation'
            dashboardAction = "my_pr"
            break;
          case "pending_po":
            url = "/po-approval";
            project='operation'
            dashboardAction = "approval_pending_po"
            break;

            case "pending_iv":
              url = "/invoice-approval";
              project='operation'
              dashboardAction = "approval_pending_iv"
              break;


            case "pending_ip":
              url = "/invoice-payment-approval";
              project='operation'
              dashboardAction = "approval_pending_ip"
              break;  
                       
      case "pending_grn":
        url = "/add-grn";
        project='operation'
        dashboardAction = "pending_grn"
        break;
      case "pending_stock_issue":
          url = "/stock-issue-approval";
          project='asset_management'
          dashboardAction = "pending_stock_issue"
          break;
      case "pending_sales_order":
        url = "/sales-order-approval";
        project='o2c'
        dashboardAction = "pending_sales_order"
        break;
      case "pending_sales_invoice":
        url = "/sales-invoice-for-approval";
        project='o2c'
        dashboardAction = "pending_sales_invoice"
        break;
      case "pending_production":
            url = "/production-record-approval";
            project='asset_management'
            dashboardAction = "pending_production"
            break;
      case "pending_ir":
        url = "/allir-approvals";
        project='operation'
        dashboardAction = "pending_ir"
        break;
      case "pending_boq":
          url = "/boq-approval";
          project='master'
          dashboardAction = "pending_boq"
          break;
      case "pending_adhoc_advance_payment":
        url = "/adhoc-advance-payment-approval";
        project='operation'
        dashboardAction = "pending_adhoc_advance_payment"
        break;
      case "rfq":
        url = "/add-rfq-approval";
        project='master'
        dashboardAction = "rfq"
        break;
        case "rfq":
        url = "/vendors";
        project='master'
        dashboardAction = "rfq"
        break;
      case "rfq_response":
        url = "/rfq-response-approval";
        project='master'
        dashboardAction = "rfq_response"
        break;
      case "journal_entry":
        url = "/je-approval";
        project='finance'
        dashboardAction = "journal_entry"
        break;
      case "pending_pr_for_rfq":
        url = "/pending-pr-for-rfq-no";
        project='operation'
        dashboardAction = "pending_pr_for_rfq"
        break;
      case "rfq":
        url = "/add-rfq";
        project='master'
        dashboardAction = "pending_add_rfq"
        break;
        case "pending_stn":
          url = "/stn-sender-approval";
          project='asset_management'
          dashboardAction = "pending_stn"
          break;
        case "cvppm_pending_approval":
            url = "/cvppm-approval";
            project='mapping'
            dashboardAction = "cvppm_pending_approval"
            break;
            case "utr_pending_to_be_updated":
              url = "/add-payment";
              project='operation'
              dashboardAction = "utr_pending_to_be_updated"
              break; 
              case "vendor_master_pending_to_be_updated":
              url = "/vendor-approval";
              project='master'
              dashboardAction = "vendor_master_pending_to_be_updated"
              break; 
              case "product_master_pending_to_be_updated":
              url = "/product-approval";
              project='master'
              dashboardAction = "product_master_pending_to_be_updated"
              break; 
              case "employee_master_pending_to_be_updated":
              url = "/employee-master-approval";
              project='master'
              dashboardAction = "employee_master_pending_to_be_updated"
              break; 
              case "hsn_master_pending_to_be_updated":
              url = "/hsn-approval";
              project='master'
              dashboardAction = "hsn_master_pending_to_be_updated"
              break;  
              case "dc_note_pending_approval":
              url = "/debit-credit-for-approvals";
              project='operation'
              dashboardAction = "dc_note_pending_approval"
              break; 
              case "customer_master_approval":
                url = "/customer-master-approval";
                project='master'
                dashboardAction = "customer_master_approval"
                break;  
                case "customer_balance_approval":
                url = "/customer-balance-approval";
                project='report'
                dashboardAction = "customer_balance_approval"
                // window.location.href=window.location.origin+'/report/#/customer-balance-approval';
                break;
                case "po_hold":
                  url = "/hold-po-for-additional-info";
                  project='operation'
                  dashboardAction = "po_hold"
                  break;
        case "technical_rfq_response":
          url = "/rfq-technical-response-approval";
          project='master'
          dashboardAction = "rfq_response"
          break;
          case "amc_due_for_renewal":
            url = "/amc-renewal-dashboard";
            project='master'
            dashboardAction = "amc_due_for_renewal"
            break;
            case "amc_card_expiry":
              url = "/amc-renewal-dashboard";
              project='master'
              dashboardAction = "amc_card_expiry"
              break;
      case "total_no_of_amc_tasks":
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "total_no_of_amc_tasks"
        break;
      case "total_active_amc_tasks":
        url = "/amc-master";
        project = 'master'
        dashboardAction = "total_active_amc_tasks"
        break;
      case "total_pending_amc_tasks":
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "total_pending_amc_tasks"
        break;
      case "amc_tasks_due_in_upcoming_days":
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "amc_tasks_due_in_upcoming_days"
        break;
      case "my_amc_today_tasks":
        // my-amc-task page + ajax_get_scheduled_tasks_by_responsible_person expect dashboard_card_type (master app reads URL / localStorage)
        localStorage.setItem("dashboard_card_type", "my_today");
        // console.log("[Dashboard] AMC card click", { cardKey: key, dashboard_card_type: "my_today" });
        url = "/my-amc-task?dashboard_card_type=my_today";
        project = 'master'
        dashboardAction = "my_amc_today_tasks"
        break;
      case "my_amc_overdue_tasks":
        localStorage.setItem("dashboard_card_type", "my_overdue");
        // console.log("[Dashboard] AMC card click", { cardKey: key, dashboard_card_type: "my_overdue" });
        url = "/my-amc-task?dashboard_card_type=my_overdue";
        project = 'master'
        dashboardAction = "my_amc_overdue_tasks"
        break;
      case "my_amc_this_week_tasks":
        localStorage.setItem("dashboard_card_type", "my_this_week");
        // console.log("[Dashboard] AMC card click", { cardKey: key, dashboard_card_type: "my_this_week" });
        url = "/my-amc-task?dashboard_card_type=my_this_week";
        project = 'master'
        dashboardAction = "my_amc_this_week_tasks"
        break;
      case "my_amc_next_week_tasks":
        localStorage.setItem("dashboard_card_type", "my_next_week");
        // console.log("[Dashboard] AMC card click", { cardKey: key, dashboard_card_type: "my_next_week" });
        url = "/my-amc-task?dashboard_card_type=my_next_week";
        project = 'master'
        dashboardAction = "my_amc_next_week_tasks"
        break;
      case "all_amc_today_tasks":
        // all-amc-tasks + ajax_get_scheduled_tasks_by_responsible_person use dashboard_card_type (master app)
        localStorage.setItem("dashboard_card_type", "all_today");
        // console.log("[Dashboard] All AMC card click", { cardKey: key, dashboard_card_type: "all_today" });
        url = "/all-amc-tasks?dashboard_card_type=all_today";
        project = 'master'
        dashboardAction = "all_amc_today_tasks"
        break;
      case "all_amc_overdue_tasks":
        localStorage.setItem("dashboard_card_type", "all_overdue");
        // console.log("[Dashboard] All AMC card click", { cardKey: key, dashboard_card_type: "all_overdue" });
        url = "/all-amc-tasks?dashboard_card_type=all_overdue";
        project = 'master'
        dashboardAction = "all_amc_overdue_tasks"
        break;
      case "all_amc_this_week_tasks":
        localStorage.setItem("dashboard_card_type", "all_this_week");
        // console.log("[Dashboard] All AMC card click", { cardKey: key, dashboard_card_type: "all_this_week" });
        url = "/all-amc-tasks?dashboard_card_type=all_this_week";
        project = 'master'
        dashboardAction = "all_amc_this_week_tasks"
        break;
      case "all_amc_next_week_tasks":
        localStorage.setItem("dashboard_card_type", "all_next_week");
        // console.log("[Dashboard] All AMC card click", { cardKey: key, dashboard_card_type: "all_next_week" });
        url = "/all-amc-tasks?dashboard_card_type=all_next_week";
        project = 'master'
        dashboardAction = "all_amc_next_week_tasks"
        break;
        case "part_payment":
          url = "/part-payment-for-approval";
          project='operation'
          dashboardAction = "part_payment"
          break;
          case "lob_master_pending_to_be_updated":
              url = "/primary-location-approval";
              project='master'
              dashboardAction = "lob_master_pending_to_be_updated"
              break; 
              case "unit_type_master_pending_to_be_updated":
              url = "/unit-type-approval";
              project='master'
              dashboardAction = "unit_type_master_pending_to_be_updated"
              break; 
              case "company_bank_master_pending_to_be_updated":
              url = "/company-bank-approval";
              project='master'
              dashboardAction = "company_bank_master_pending_to_be_updated"
              break; 
              case "account_master_pending_to_be_updated":
              url = "/account-master-approval";
              project='master'
              dashboardAction = "account_master_pending_to_be_updated"
              break; 
              case "tds_master_pending_to_be_updated":
              url = "/tds-approval";
              project='master'
              dashboardAction = "tds_master_pending_to_be_updated"
              break; 
              case "department_master_pending_to_be_updated":
              url = "/department-approval";
              project='master'
              dashboardAction = "department_master_pending_to_be_updated"
              break;
              case "pending_amc_task_approval":
                url = "/task-approvals";
                project = 'master';
                dashboardAction = "pending_amc_task_approval";
                break;
              case "user_role_master_pending_to_be_updated":
              url = "/user-role-approval";
              project='settings'
              dashboardAction = "user_role_master_pending_to_be_updated"
              break;
              case "reason_master_pending_to_be_updated":
                url = "/reason-master-approval";
                project = 'master'
                dashboardAction = "reason_master_pending_to_be_updated"
                break;
              case "line_of_business_master_pending_to_be_updated":
                url = "/lob-master-approval";
                project = 'master'
                dashboardAction = "line_of_business_master_pending_to_be_updated"
                break;
                   
        default:
          url = "";
    }

    localStorage.setItem("dashboardAction", this.webService.set(dashboardAction,'dashboardAction'));
    localStorage.setItem("dashboardAction_isTotal", this.webService.set(isTotal,'dashboardAction_isTotal'));

    if(url!=''&&url!=undefined)
    {
      let redirectUrl = '/#';
      let origin = window.location.origin;
      if (project == 'master') {
        redirectUrl = origin + '/master' + redirectUrl + url;
      } else if (project == 'settings') {
        redirectUrl = origin + '/settings' + redirectUrl + url;
      } else if (project == 'report') {
        redirectUrl = origin + '/report' + redirectUrl + url;
      } else if (project == 'mapping') {
        redirectUrl = origin + '/mapping' + redirectUrl + url;
      } else if (project == 'finance') {
        redirectUrl = origin + '/finance' + redirectUrl + url;
      }
      else if (project == 'project_management') {
        redirectUrl = origin + '/project_management' + redirectUrl + url;
      }
      else if (project == 'help_desk') {
        redirectUrl = origin + '/help_desk' + redirectUrl + url;
      }else if (project == 'o2c') {
        redirectUrl = origin + '/o2c' + redirectUrl + url;
      }
     else if (project == 'asset_management') {
      redirectUrl = origin + '/asset_management' + redirectUrl + url;
    }

      else {
        if (url == '#' || !url) return;
        this.webService.redirectURL(url);
        return;
      }
      window.location.href = redirectUrl;
    }
  }
  navigatePendingPmRaiseTaskByUrl(key)
  {
    let url = "";
    let project = '';
    let dashboardAction = "";
    switch (key) {
      case "pending_timesheet":
        project = 'project_management'
        dashboardAction = "pending_timesheeet"
        localStorage.setItem('pm_dashboard_action',dashboardAction)
      //  window.location.href=window.location.origin+'/project_management/#/time-sheet-weekly';
      if(!this.IS_VAILID_URL("/time-sheet-v2") && !this.IS_VAILID_URL("/time-sheet-weekly")){
        this.toasterService.pop("info", "Info", "You dont have Access Of This Page");
        return false
      }
      if(this.IS_VAILID_URL("/time-sheet-v2") && this.IS_VAILID_URL("/time-sheet-weekly")){
        window.location.href=window.location.origin+'/project_management/#/time-sheet-v2';
      }else if(this.IS_VAILID_URL("/time-sheet-v2")) {
        window.location.href=window.location.origin+'/project_management/#/time-sheet-v2';
      } else if(this.IS_VAILID_URL("/time-sheet-weekly")) {
        window.location.href=window.location.origin+'/project_management/#/time-sheet-weekly';
      }else {
        window.location.href=window.location.origin+'/project_management/#/time-sheet-v2';
      }
        break;

        case "pending_project":
          project = 'project_management'
          dashboardAction = "pending_project"
          localStorage.setItem('pm_dashboard_action',dashboardAction)
          window.location.href=window.location.origin+'/project_management/#/my-project-master';

           break;

        case "pending_expense":
          project = 'project_management'
        dashboardAction = "pending_expense"
        localStorage.setItem('pm_dashboard_action',dashboardAction)
      window.location.href=window.location.origin+'/project_management/#/expense-sheet-v2';

        break;

        case "pending_task":
          project = 'project_management'
        dashboardAction = "pending_task"
        localStorage.setItem('pm_dashboard_action',dashboardAction)
       window.location.href=window.location.origin+'/project_management/#/my-task-master';
                break;
                case "pending_questionnaire":
                  project = 'master'
                dashboardAction = "pending_rfq"
                localStorage.setItem('master_dashboard_action',dashboardAction)
               window.location.href=window.location.origin+'/master/#/questionnaire-for-my-approval';
              break;
               case "pending_vendor_rating":
                project = 'master'
              dashboardAction = "pending_rfq"
              localStorage.setItem('master_dashboard_action',dashboardAction)
             window.location.href=window.location.origin+'/master/#/rate-vendor';
             break;
                case "rfq":
                  project = 'master'
                dashboardAction = "pending_rfq"
                localStorage.setItem('master_dashboard_action',dashboardAction)
               window.location.href=window.location.origin+'/master/#/add-rfq';
                        break;

                        case "rfq_response":
                          project = 'master'
                        dashboardAction = "pending_rfq_response"
                        localStorage.setItem('master_dashboard_action',dashboardAction)
                       window.location.href=window.location.origin+'/master/#/view-rfq-response';
                                break;
                                case "journal_entry":
                                  project = 'finance'
                                dashboardAction = "pending_je"
                                localStorage.setItem('finance_dashboard_action',dashboardAction)
                               window.location.href=window.location.origin+'/master/#/my-pending-je';
                                        break;


      case "raise_pending_po":
        url = "/raise-po";
        project='operation'
        dashboardAction = "raise_pending_po"
        break;

        case "pending_pr":
        url = "/allpr-approvals";
        project='operation'
        dashboardAction = "pending_pr"
        break;
        case "recurring_invoice":
          url = "/auto-generated-inv";
          project='operation'
          dashboardAction = "pending_recurring_invoice"
          break;
        case "my_pr":
          url = "/my-purchases-pr";
          project='operation'
          dashboardAction = "my_pr"
          break;

        case "raise_pending_irn":
        url = "/new-irn";
        project='operation'
        dashboardAction = "raise_pending_irn"
        break;




        case "raise_pending_grn":
        url = "/add-grn";
        project='operation'
        dashboardAction = "raise_pending_grn"
        break;

        case "pr_hold":
          url = "/hold-pr-for-additional-info";
          project='operation'
          dashboardAction = "pr_hold"
          break;

          case "po_hold":
            url = "/hold-po-for-additional-info";
            project='operation'
            dashboardAction = "po_hold"
            break;

      case "raise_pending_iv":
        url = "/add-invoice-v2";
        project='operation'
        dashboardAction = "raise_pending_iv"
        break;


      case "raise_pending_ip":
        url = "/add-invoice-payments";
        project='operation'
        dashboardAction = "raise_pending_ip"
        break;

        case "raise_pending_production":
          project = 'asset_management'
        dashboardAction = "pending_production"
        localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))
       window.location.href=window.location.origin+'/asset_management/#/my-production-record';
                break;

                case "raise_pending_boq":
                  project = 'master'
                dashboardAction = "pending_boq"
                localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))
               window.location.href=window.location.origin+'/master/#/boq';
                        break;

                        case "raise_pending_ir":
                          url = "/my-ir";
                          project = 'operation'
                        dashboardAction = "pending_ir"
                        localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))
                        localStorage.setItem('dashboardAction',this.eesdesService.set(dashboardAction))

                                break;

                                case "raise_pending_sales_invoice":
                                  project = 'o2c'
                                dashboardAction = "pending_sales_invoice"
                                localStorage.setItem('dashboardAction',this.eesdesService.set(dashboardAction))
                                localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))

                               window.location.href=window.location.origin+'/o2c/#/my-sales-invoice';
                                        break;

                                        case "raise_pending_sales_order":
                                          project = 'o2c'
                                        dashboardAction = "pending_so"
                                        localStorage.setItem('dashboardAction',this.eesdesService.set(dashboardAction))
                                        localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))

                                       window.location.href=window.location.origin+'/o2c/#/my-sales-order';
                                                break;
                                              

                                                case "pending_raised_stock":
                                                  project = 'asset_management'
                                                dashboardAction = "pending_si"
                                                // Plain value for asset_management cross-app (eesdesService.set returns undefined when encryption is off)
                                                localStorage.setItem('dashboard_action', dashboardAction)
                                                localStorage.setItem('action_type', dashboardAction)
                                                localStorage.setItem('dashboardAction', this.eesdesService.set(dashboardAction))
                                               window.location.href=window.location.origin+'/asset_management/#/my-stock-issue';
                                                        break;
                                                        case "pending_pr_for_rfq":
                                                        url = "/pending-pr-for-rfq-no";
                                                        project='operation'
                                                        dashboardAction = "pending_pr_for_rfq"
                                                        break;
        // case "Approved_e":
        //   url = "/add-invoice-payments";
        //   project='project-'
        //   dashboardAction = "raise_pending_ip"
        //   break;
        case "advance_payament_raiser":
          url = "/adhoc-advance-payment";
          project='operation'
          dashboardAction = "advance_payament_raiser"
          break;
          case "all_approved_rfq_response":
          project = 'master'
          dashboardAction = "all_approved_rfq_response"
          localStorage.setItem('master_dashboard_action',dashboardAction)
          console.log( localStorage.getItem('master_dashboard_action'))
         window.location.href=window.location.origin+'/master/#/all-approved-rfq-response';
         break;
         case "vendor_invoice_dashboard":
          url = "/invoice-dashboard";
          project='operation'
          dashboardAction = "vendor_invoice_dashboard"
          break;
          case "vendor_delivery_dashboard":
            url = "/vendor-irn-dashboard";
            project='operation'
            dashboardAction = "vendor_delivery_dashboard"
            break;
          case "customer_balance_approval":
            url = "/customer-balance-approval";
            project='report'
            dashboardAction = "customer_balance_approval"
            localStorage.setItem('report_dashboard_action',dashboardAction)
            window.location.href=window.location.origin+'/report/#/customer-balance-approval';
            break;

        case "technical_rfq_response":
          project = 'master'
          dashboardAction = "pending_rfq_response"
          localStorage.setItem('master_dashboard_action',dashboardAction)
          window.location.href=window.location.origin+'/master/#/rfq-technical-response';

          case "amc_due_for_renewal":
            // url = "/amc-renewal-dashboard";
            project = 'master'
            dashboardAction = "amc_due_for_renewal"
            localStorage.setItem('amc_card_type',dashboardAction)
            window.location.href=window.location.origin+'/master/#/amc-renewal-dashboard';
            break;
            case "amc_card_expiry":
              project = 'master'
              dashboardAction = "amc_card_expiry"
              localStorage.setItem('amc_card_type',dashboardAction)
              window.location.href=window.location.origin+'/master/#/amc-renewal-dashboard';
              break;
              case "total_no_of_amc_tasks":
                project = 'master'
                dashboardAction = "total_no_of_amc_tasks"
                localStorage.setItem('amc_card_type',dashboardAction)
                window.location.href=window.location.origin+'/master/#/all-amc-tasks';
                break;
              case "total_active_amc_tasks":
                project = 'master'
                dashboardAction = "total_active_amc_tasks"
                localStorage.setItem('amc_card_type',dashboardAction)
                window.location.href=window.location.origin+'/master/#/amc-master';
                break;
              case "total_pending_amc_tasks":
                project = 'master'
                dashboardAction = "total_pending_amc_tasks"
                localStorage.setItem('amc_card_type',dashboardAction)
                window.location.href=window.location.origin+'/master/#/all-amc-tasks';
                break;
              case "amc_tasks_due_in_upcoming_days":
                project = 'master'
                dashboardAction = "amc_tasks_due_in_upcoming_days"
                localStorage.setItem('amc_card_type',dashboardAction)
                window.location.href=window.location.origin+'/master/#/all-amc-tasks';
              break;         
        case "part_payment":
          url = "/part-payment";
          project='operation'
          dashboardAction = "part-payment"
          break;
        case 'mailed_invoice':
          url = "/mailed-invoice";
          project='operation'
          dashboardAction = "mailed-invoice"
          break;
        case 'adhoc_advance_payment':
          url = "/adhoc-advance-payment";
          project = 'operation'
          dashboardAction = "adhoc_advance_payment"
          break;
          case "raise_pending_srn":
            url = "/new-srn";
            project='operation'
            dashboardAction = "raise_pending_srn"
            break;
          case "pending_amc_task_approval":
            project = 'master'
            dashboardAction = "pending_amc_task_approval"
            break;
        case 'failed_mailed_invoice':
          // Open Mailed Invoice page on "failed" tab
          try {
            localStorage.setItem('mailed_invoice_pagination', JSON.stringify({
              activeTab: 'failed',
              inProcessPage: 1,
              inProcessRowsPerPage: 20
            }));
          } catch (e) {}
          url = "/mailed-invoice";
          project='operation'
          dashboardAction = "failed-mailed-invoice"
          break;
          case "pending_amc_task_approval":
            project = 'master'
            dashboardAction = "pending_amc_task_approval"
            break;
        case "raise_pending_srn":
            url = "/new-srn";
            project='operation'
            dashboardAction = "raise_pending_srn"
            break;
        default:
          url = "";
    }

   localStorage.setItem("dashboardAction", this.eesdesService.set(dashboardAction))
    if(url!=''&&url!=undefined)
    {
      let redirectUrl = '/#';
      let origin = window.location.origin;
      if (project == 'master') {
        redirectUrl = origin + '/master' + redirectUrl + url;
      } else if (project == 'report') {
        redirectUrl = origin + '/report' + redirectUrl + url;
      } else if (project == 'mapping') {
        redirectUrl = origin + '/mapping' + redirectUrl + url;
      } else if (project == 'finance') {
        redirectUrl = origin + '/finance' + redirectUrl + url;
      }
      else if (project == 'project_management') {
        redirectUrl = origin + '/project_management' + redirectUrl + url;
      }
      else if (project == 'help_desk') {
        redirectUrl = origin + '/help_desk' + redirectUrl + url;
      }

      else {
        if (url == '#' || !url) return;
        this.webService.redirectURL(url);
        return;
      }
      window.location.href = redirectUrl;
    }
  }

  getTaskNamePM(key,title,isTotal='1') {

    let name = "";

    switch (key) {

      case "pending_timesheet":
        name='Click to go '+title+" Page"
        break;

      case "pending_project":
        name='Click to go '+title+" Page"
        break;

      case "pending_expense":
        name='Click to go '+title+" Page"
        break;
      case "cvppm_pending_approval":
        name = `Click to go ${title} Page`
        break;
      case "utr_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "vendor_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "product_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "employee_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "hsn_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "dc_note_pending_approval":
        name = `Click to go ${title} Page`
        break;
        case "customer_master_approval":
        name = `Click to go ${title} Page`
        break;
        case "customer_balance_approval":
        name = `Click to go ${title} Page`
        break;
        case "po_hold":
          name = `Click to go ${title} Page`
          break;
      case "pending_task":
        name='Click to go '+title+" Page"
        break;

        case "pending_pr":
        name='Click to go '+title+" Page"
        break;
        case "recurring_invoice":
          name = `Click to go ${title} Page`
          break;
          case "cvppm_pending_approval":
            name = `Click to go ${title} Page`
            break;
          case "utr_pending_to_be_updated":
              name = `Click to go ${title} Page`
              break;
              case "vendor_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "lob_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "unit_type_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "company_bank_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "account_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "tds_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "department_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              
                case "line_of_business_master_pending_to_be_updated":
                  name = `Click to go ${title} Page`
                  break;
                case "user_role_master_pending_to_be_updated":
                  name = `Click to go ${title} Page`
                  break;
                case "reason_master_pending_to_be_updated":
                  name = `Click to go ${title} Page`
                  break;
              
            
      case "pending_po":
        name='Click to go '+title+" Page"
        break;
      case "pending_iv":
        name='Click to go '+title+" Page"
        break;

      case "pending_ip":
        name='Click to go '+title+" Page"
        break;

        case "raise_pending_po":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_irn":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_grn":
        name='Click to go '+title+" Page"
        break;
        case "pending_grn":
          name='Click to go '+title+" Page"
          break;
        case "raise_pending_iv":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_ip":
        name='Click to go '+title+" Page"
        break;
        case "raise_recurring_invoice":
          name='Click to go '+title+" Page"
          break;

          case "recurring_invoice":
            name='Click to go '+title+" Page"
            break;

            case "pending_questionnaire":
              name='Click to go '+title+" Page"
              break;

              case "pending_vendor_rating":
                name='Click to go '+title+" Page"
                break;

                case "vendor_invoice_dashboard":
                  name='Click to go '+title+" Page"
                  break;
                  case "vendor_delivery_dashboard":
                    name='Click to go '+title+" Page"
                    break;  
      case "technical_rfq_response":
        name = `Click to go ${title} Page`
        break;
        case "amc_due_for_renewal":
          name = `Click to go ${title} Page`
          break;
        case "amc_card_expiry":
          name = `Click to go ${title} Page`
          break;
          case "total_no_of_amc_tasks":
            name = `Click to go ${title} Page`
            break;
          case "total_active_amc_tasks":
            name = `Click to go ${title} Page`
            break;
          case "total_pending_amc_tasks":
            name = `Click to go ${title} Page`
            break;
          case "amc_tasks_due_in_upcoming_days":
          name = `Click to go ${title} Page`
          break;
      case "part_payment":
        name = `Click to go ${title} Page`
        break;
      case 'mailed_invoice':
        name = `Click to go ${title} Page`
        break;
        case "pending_amc_task_approval":
          name = `Click to go ${title} Page`
          break;
      case 'failed_mailed_invoice':
        name = `Click to go ${title} Page`
        break;
      case "raise_pending_srn":
          name = `Click to go ${title} Page`
          break;
      default:
        name = "";
    }
    if(name!='' && isTotal!='1')
    {
      name=name+" and get info For Last "+this.company_setup.how_many_days_pending_in_dashboard+" Days"
    }
   return name;
  }


  pendingTaskTitleForVendor:any='';
  pendingTaskListForVendor:any= [];
  pendingTaskCountForVendor:any = 0;
  pendingTaskCountVendor:any=0;
  getPendingTaskForVendor(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() !== "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingTaskCountVendor = "";
    let localCount:any = 0;
    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }
    this.pendingTaskListForVendor=[];
    this.runDashboardCounterHttp(
      "Vendor_management/ajax_dashboard_pending_cards_sorted",
      obj,
      onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
      (data) => {
          if (data.status) {
            let temp :any =[];
            if(data.response){
              for(let i of data.response)
              {
                for(let j of i.items)
                {
                  temp.push(j);
                }
              }
            }

            this.pendingTaskListForVendor=temp?temp:[];
            this.pendingTaskTitleForVendor=data.response.length>0?data.response[0].title:'';
            if(this.pendingTaskListForVendor){
              for(let totalCount of this.pendingTaskListForVendor) {
                totalCount.count = this.webService.convertNaN(totalCount.count) ? this.webService.convertNaN(totalCount.count) : 0;
                if( totalCount.count !=""){
                  if(this.isPendingCardVisibleForVendor(totalCount.key)){
                    localCount += parseFloat(totalCount.count);
                  }
                }
              }
            }
            this.pendingTaskCountForVendor = localCount ? localCount : 0;
           }
          //  console.log(this.pendingTaskListForVendor);
           this.dashboardProjectLoader = false

        },
        () => {
          this.dashboardProjectLoader = false

        }
      );
  }
  isPendingCardVisibleForVendor(id)
  {
    if(id!=''&&id!=undefined)
    {
      id=id.replace("raise_", "")
    }
    // return true
    return this.company_setup.vendor_dashboard_notification.some((v)=>{return v.id==id && v.is_visible_on_vendor_dashboard})
  }
  getTaskNameVendor(key,title) {

    let name = "";

    switch (key) {

      case "pending_timesheet":
        name='Click to go '+title+" Page"
        break;

      case "pending_project":
        name='Click to go '+title+" Page"
        break;

      case "pending_expense":
        name='Click to go '+title+" Page"
        break;
        case "cvppm_pending_approval":
          name = `Click to go ${title} Page`
          break;
        case "utr_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "vendor_master_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "product_master_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "employee_master_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "hsn_master_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "dc_note_pending_approval":
            name = `Click to go ${title} Page`
            break;
      case "pending_task":
        name='Click to go '+title+" Page"
        break;

        case "pending_pr":
        name='Click to go '+title+" Page"
        break;
        case "recurring_invoice":
          name='Click to go '+title+" Page"
          break;
          case "cvppm_pending_approval":
            name='Click to go '+title+" Page"
            break;
            case "utr_pending_to_be_updated":
              name='Click to go '+title+" Page"
              break;
              case "vendor_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "lob_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "unit_type_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "company_bank_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "account_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "tds_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "department_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "product_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
                case "employee_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
                case "hsn_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
                case "dc_note_pending_approval":
                name='Click to go '+title+" Page"
                break;
                case "customer_master_approval":
                name = `Click to go ${title} Page`
                break;
                case "customer_balance_approval":
                name = `Click to go ${title} Page`
                break;
                case "po_hold":
                  name = `Click to go ${title} Page`
                  break;
      case "pending_po":
        name='Click to go '+title+" Page"
        break;
      case "pending_iv":
        name='Click to go '+title+" Page"
        break;

      case "pending_ip":
        name='Click to go '+title+" Page"
        break;

        case "raise_pending_po":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_irn":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_grn":
        name='Click to go '+title+" Page"
        break;
        case "pending_grn":
          name='Click to go '+title+" Page"
          break;
        case "raise_pending_iv":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_ip":
        name='Click to go '+title+" Page"
        break;
        case "vendor_invoice_dashboard":
        name='Click to go '+title+" Page"
        break;
        case "vendor_delivery_dashboard":
        name='Click to go '+title+" Page"
        break;
      case "technical_rfq_response":
        name = `Click to go ${title} Page`
        break;
        case "amc_due_for_renewal":
        name = `Click to go ${title} Page`
        break;
        case "amc_card_expiry":
        name = `Click to go ${title} Page`
        break;
      case "total_no_of_amc_tasks":
        name = `Click to go ${title} Page`
        break;
      case "total_active_amc_tasks":
        name = `Click to go ${title} Page`
        break;
      case "total_pending_amc_tasks":
        name = `Click to go ${title} Page`
        break;
      case "amc_tasks_due_in_upcoming_days":
        name = `Click to go ${title} Page`
        break;
       case "part_payment":
        name = `Click to go ${title} Page`
        break;
      case 'mailed_invoice':
        name = `Click to go ${title} Page`
        break;
        case "pending_amc_task_approval":
          name = `Click to go ${title} Page`
          break;
      case 'failed_mailed_invoice':
        name = `Click to go ${title} Page`
        break;
      case "raise_pending_srn":
        name = `Click to go ${title} Page`
        break;
      case "user_role_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
      case "reason_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
   
      case "line_of_business_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
      default:
        name = "";
    }
   return name;
  }
  vendorPOPieChartType:any='pie';
  vendorPOPieChartLabelsList:any=[];
  vendorPOPieChartList:any=[];
  vendorPoPieCharttTitle:any='Submain';
  vendorPoPiechartMainTitle:any='Main';
  isVendorPOPieChartLoading:boolean=true;
  vendorPOPieChartCount:any=0;
  getVendorPOStatics(onComplete?: () => void)
  {
  if (!this.isDashboardActive()) {
    return;
  }

  if (this._localStorageService.getUserRole() !== "vendor") {
    this.isVendorPOPieChartLoading=false
    this.continueDashboardCounterChain(onComplete);
    return;
  }
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  }
  this.vendorPOPieChartLabelsList=[];
  this.vendorPOPieChartList=[];
  this.runDashboardCounterHttp(
    "Vendor_management/ajax_dashboard_pending_cards_sorted_V2",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
        if (data.status) {
          let list:any=[data.response?data.response:{}];

          let temp:any=[];
          let color:any=[];
          if(list)
          {
            for(let j of list)
            {
              if(j.items)
              {
                for(let i of j.items)
                {
                  // let count=i.count.length;
                  // let count=i.sum?i.sum:'0';
                  // console.log('count',count);
                  

              // let name=i.title;
              let name=i.title + " (" + i.count + ")";
              this.vendorPOPieChartCount=parseFloat(this.vendorPOPieChartCount)+parseFloat(this.webService.convertNaN(i.sum))
              this.vendorPOPieChartCount=this.webService.convertNaN(this.vendorPOPieChartCount);
              this.vendorPOPieChartLabelsList.push(name);
             temp.push(this.webService.convertNaN(i.sum));
             color.push(i.color);
              }
            }
          }
            this.vendorPOPieChartList=[
              {
                title:"PO Statistics",
                  type: 'pie',
                // data:  [12, 10, 15, 10, 40, 13],
                data:  temp?temp:[],
                backgroundColor:color?color:[]

              }
            ]

          }
  }
  else
  {
    this.isVendorPOPieChartLoading=false

  }
  this.isVendorPOPieChartLoading=false;
},
() => {
  this.isVendorPOPieChartLoading=false

}
);
}
  pmCardVisibleAccordingUserRole(key){
    let status:boolean=true;
    switch(key){
    case 'all_project':
    status= this.company_setup.dashboard_cards_according_to_user_role_pm.some((v)=>{return v.id == key && v.user_role_list.some((d)=>{return parseInt(d.item_id) == parseInt(this.employeeUserRoleId)})});
    break;
    default:
  status=true;
}
return status;
}



vendorInvoicePieChartType:any='pie';
  vendorInvoicePieChartLabelsList:any=[];
  vendorInvoicePieChartList:any=[];
  vendorInvoicePieCharttTitle:any='Submain';
  vendorInvoicePiechartMainTitle:any='Main';
  isVendorInvoicePieChartLoading:boolean=true;
  vendorInvoicePieChartCount:any=0;
  getVendorInvoiceStatics(onComplete?: () => void)
  {
  if (!this.isDashboardActive()) {
    return;
  }

  if (this._localStorageService.getUserRole() !== "vendor") {
    this.isVendorInvoicePieChartLoading=false
    this.continueDashboardCounterChain(onComplete);
    return;
  }
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  }
  this.vendorInvoicePieChartLabelsList=[];
  this.vendorInvoicePieChartList=[];
  this.runDashboardCounterHttp(
    "Vendor_management/ajax_dashboard_pending_cards_sorted_V4",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
        if (data.status) {
          let list:any=[data.response?data.response:{}];

          let temp:any=[];
          let color:any=[];
          if(list)
          {
            for(let j of list)
            {
              if(j.items)
              {
                for(let i of j.items)
                {
              let name=i.title + " (" + i.count + ")";
              this.vendorInvoicePieChartCount=parseFloat(this.vendorInvoicePieChartCount)+parseFloat(this.webService.convertNaN(i.sum))
              this.vendorInvoicePieChartCount=this.webService.convertNaN(this.vendorInvoicePieChartCount);
              this.vendorInvoicePieChartLabelsList.push(name);
             temp.push(this.webService.convertNaN(i.sum));
             color.push(i.color);
              }
            }
          }
            this.vendorInvoicePieChartList=[
              {
                title:"Invoice Statistics",
                  type: 'pie',
                // data:  [12, 10, 15, 10, 40, 13],
                data:  temp?temp:[],
                backgroundColor:color?color:[]

              }
            ]

          }

  }
  else
  {

  }
  this.isVendorInvoicePieChartLoading=false

},
() => {
  this.isVendorInvoicePieChartLoading=false

}
);
}

po_till_date_vendorPObarChartType:any='bar';
po_till_date_vendorPObarChartLabelsList:any=[];
po_till_date_vendorPObarChartList:any=[];
po_till_date_vendorPobarCharttTitle:any='Submain';
po_till_date_vendorPobarchartMainTitle:any='Main';
po_till_date_isVendorPObarChartLoading:boolean=true;
po_till_date_vendorPObarChartCount:any='';


po_not_dis_till_date_vendorPObarChartType:any='bar';
po_not_dis_till_date_vendorPObarChartLabelsList:any=[];
po_not_dis_till_date_vendorPObarChartList:any=[];
po_not_dis_till_date_vendorPobarCharttTitle:any='Submain';
po_not_dis_till_date_vendorPobarchartMainTitle:any='Main';
po_not_dis_till_date_isVendorPObarChartLoading:boolean=true;
po_not_dis_till_date_vendorPObarChartCount:any='';

getVendorPOBarStatics(onComplete?: () => void)
{
if (!this.isDashboardActive()) {
  return;
}

if (this._localStorageService.getUserRole() !== "vendor") {
  this.po_till_date_isVendorPObarChartLoading=false
  this.po_not_dis_till_date_isVendorPObarChartLoading=false;
  this.continueDashboardCounterChain(onComplete);
  return;
}
let obj = {
  "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
  "company_id": this._localStorageService.getEmpCompanyId(),
}
this.po_till_date_vendorPObarChartLabelsList=[];
this.po_till_date_vendorPObarChartList=[];

this.po_not_dis_till_date_vendorPObarChartLabelsList=[];
this.po_not_dis_till_date_vendorPObarChartList=[];

this.runDashboardCounterHttp(
  "Vendor_management/ajax_dashboard_pending_cards_sorted_V3",
  obj,
  onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
  (data) => {
      if (data.status) {
        let list:any=[data.response.items[0]?data.response.items[0]:{}];


        if(list)
        {
          for(let i of list)
          {
                if(i.count.length>0)
                {
                  for(let k of i.count)
                  {
                    let count=k.total_items;
                    let name=i.title;
                    this.po_till_date_vendorPObarChartCount=parseFloat(this.po_till_date_vendorPObarChartCount)+parseFloat(this.webService.convertNaN(count))
                    this.po_till_date_vendorPObarChartCount=this.webService.convertNaN(this.po_till_date_vendorPObarChartCount);
                    this.po_till_date_vendorPObarChartLabelsList.push(k.product_name);


                   this.po_till_date_vendorPObarChartList.push({
                     type: 'bar',
                     label: k.product_name,
                     data: k.total_items,
                     fill: false,
                     borderColor: k.color,
                     pointStyle: 'spline',
                     pointBorderWidth: 7,
                     display: true,
                     backgroundColor:k.color,
                   })
            }
          }
          this.po_till_date_vendorPobarchartMainTitle=i.title+"("+this.po_till_date_vendorPObarChartCount+")";

        }

          // console.log(this.po_till_date_vendorPObarChartList);
          // console.log(this.po_till_date_vendorPObarChartLabelsList)
        }

        let list1:any=[data.response.items[1]?data.response.items[1]:{}];


        if(list1)
        {
          for(let i of list1)
          {
                if(i.count.length>0)
                {
                  for(let k of i.count)
                  {
                    let count=k.total_items;
                    let name=i.title;
                    this.po_not_dis_till_date_vendorPObarChartCount=parseFloat(this.po_not_dis_till_date_vendorPObarChartCount)+parseFloat(this.webService.convertNaN(count))
                    this.po_not_dis_till_date_vendorPObarChartCount=this.webService.convertNaN(this.po_not_dis_till_date_vendorPObarChartCount);
                    this.po_not_dis_till_date_vendorPObarChartLabelsList.push(k.product_name);


                   this.po_not_dis_till_date_vendorPObarChartList.push(
                    {
                     type: 'bar',
                     label: k.product_name,
                     data: k.total_items,
                     fill: false,
                     backgroundColor:k.color,
                     borderColor: k.color,
                     pointStyle: 'spline',
                     pointBorderWidth: 7,
                     display: true,
                   })

            }
          }

          this.po_not_dis_till_date_vendorPobarchartMainTitle=i.title +"("+this.po_not_dis_till_date_vendorPObarChartCount+")";

        }
        }
}
else
{

}
this.po_till_date_isVendorPObarChartLoading=false
this.po_not_dis_till_date_isVendorPObarChartLoading=false;


},
() => {
this.po_till_date_isVendorPObarChartLoading=false
this.po_not_dis_till_date_isVendorPObarChartLoading=false;


}
);
}
getPageUrl(data,type)
{
let url:any='';

switch(data.id)
{
  case 'pending_pr':
    url=type=='RAISE'?'/raisepr':'/allpr-approvals';
  break;
  case 'recurring_invoice':
    url=type=='RAISE'?'/auto-generated-inv':'/recurring-inv-for-approval';
  break;
  case 'pending_stock_issue':
    url=type=='RAISE'?'/raise-stock-issue':'/stock-issue-approval';
  break;
  case 'pending_po':
    url=type=='RAISE'?'/raise-po':'/po-approval';
  break;
  case 'pending_irn':
    url=type=='RAISE'?'/new-irn':'/add-grn';
  break;
  case 'pending_grn':
    url=type=='RAISE'?'/add-grn':'/add-grn';
  break;
  case 'pending_iv':
    url=type=='RAISE'?'/add-invoice-v2':'/invoice-approval';
  break;
    case 'pending_ip':
    url=type=='RAISE'?'/add-invoice-payments':'/invoice-payment-approval';
  break;
  case 'pending_sales_order':
    url=type=='RAISE'?'/sales-order-creation':'/sales-order-approval';
  break;
  case 'pending_sales_invoice':
    url=type=='RAISE'?'/sales-invoice':'/sales-invoice-for-approval';
  break;
  case 'pending_production':
    url=type=='RAISE'?'/multi-step-production':'/production-record-approval';
  break;
  case 'pending_ir':
    url=type=='RAISE'?'/raiseir':'/allir-approvals';
  break;
  case 'my_todays_tasks':
  case 'my_overdue_tasks':
  case 'my_this_week_tasks':
  case 'my_next_week_tasks':
    url = '/my-amc-task';
  break;
  case 'all_todays_tasks':
  case 'all_overdue_tasks':
  case 'all_this_week_tasks':
  case 'all_next_week_tasks':
    url = '/all-amc-tasks';
  break;
  case 'pending_boq':
    url=type=='RAISE'?'/boq':'/boq-approval';
  break;
  case 'cvppm_pending_approval':
    url=type=='RAISE'?'/mapping':'/cvppm-approval';
  break;
  case 'utr_pending_to_be_updated':
    url=type=='RAISE'?'/operation':'/add-payment';
  break;
  case 'vendor_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/vendor-approval';
  break;
  case 'product_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/product-approval';
  break;
  case 'employee_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/employee-master-approval';
  break;
  case 'hsn_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/hsn-approval';
  break;
  case 'dc_note_pending_approval':
    url=type=='RAISE'?'/debit-credit-for-approvals':'/debit-credit-for-approvals';
  break;
  case 'pr_hold ':
    url=type=='RAISE'?'/hold-pr-for-additional-info':'/hold-pr-for-additional-info';
  break;
  case 'pr_hold':
    url=type=='RAISE'?'/hold-pr-for-additional-info':'/hold-pr-for-additional-info';
  break;
  case 'po_hold':
    url=type=='RAISE'?'/hold-po-for-additional-info':'/hold-po-for-additional-info';
  break;
  case 'pending_adhoc_advance_payment':
    url=type=='RAISE'?'/adhoc-advance-payment-approval':'/adhoc-advance-payment-approval';
  break;
  case 'rfq':
    url=type=='RAISE'?'/add-rfq-approval':'/add-rfq-approval';
  break;
  case 'rfq_response':
    // url=type=='RAISE'?'/view-rfq-response':'/view-rfq-response';
    url=type=='RAISE'?'/rfq-response-approval':'/rfq-response-approval';
  break;
  case 'journal_entry':
    url=type=='RAISE'?'/je-approval':'/je-approval';
  break;
  case 'pending_pr_for_rfq':
    url=type=='RAISE'?'/pending-pr-for-rfq-no':'/pending-pr-for-rfq-no';
  break;
  case 'advance_payament_raiser':
    url=type=='RAISE'?'/adhoc-advance-payment':'/adhoc-advance-payment';
  break;
  case 'pending_vendor_rating':
    url=type=='RAISE'?'/rate-vendor':'/rated-vendor';
  break;
  case 'pending_questionnaire':
    url=type=='RAISE'?'/questionnaire-template':'/questionnaire-for-my-approval';
  break;
  case 'all_approved_rfq_response':
    url=type=='RAISE'?'/all-approved-rfq-response':'/all-approved-rfq-response';
  break;
  case 'pending_stn':
    url=type=='RAISE'?'/stn-sender-approval':'/stn-sender-approval';
  break;
  case 'cvppm_pending_approval':
    url=type=='RAISE'?'/cvppm-approval':'/cvppm-approval';
  break;
  case '  utr_pending_to_be_updated':
    url=type=='RAISE'?'/add-payment':'/add-payment';
  break;
  case 'vendor_invoice_dashboard':
    url=type=='RAISE'?'/invoice-dashboard':'/invoice-dashboard';
  break;
  case 'vendor_delivery_dashboard':
    url=type=='RAISE'?'/vendor-irn-dashboard':'/vendor-irn-dashboard';
  break;
  case 'customer_master_approval':
    url=type=='RAISE'?'/master':'/customer-master-approval';
  break;
  case 'customer_balance_approval':
    url=type=='RAISE'?'/report':'/customer-balance-approval';
  break;
  case "technical_rfq_response":
    url=type=='RAISE'?'/rfq-technical-response-approval':'/rfq-technical-response-approval';
    break;
    case "amc_due_for_renewal":
    url=type=='RAISE'?'/amc-renewal-dashboard':'/amc-renewal-dashboard';
    break;
    case "amc_card_expiry":
    url=type=='RAISE'?'/amc-renewal-dashboard':'/amc-renewal-dashboard';
    break;
    case "total_no_of_amc_tasks":
    url=type=='RAISE'?'/all-amc-tasks':'/all-amc-tasks';
    break;
    case "total_active_amc_tasks":
    url=type=='RAISE'?'/amc-master':'/amc-master';
    break;
    case "total_pending_amc_tasks":
    url=type=='RAISE'?'/all-amc-tasks':'/all-amc-tasks';
    break;
    case "amc_tasks_due_in_upcoming_days":
    url=type=='RAISE'?'/all-amc-tasks':'/all-amc-tasks';
    break;
  case 'part_payment':
    url=type=='RAISE'?'/part-payment':'/part-payment-for-approval';
    break;
  case 'mailed_invoice':
    url=type=='RAISE'?'/mailed-invoice':'/mailed-invoice';
    break;
  case 'adhoc_advance_payment':
    url=type=='RAISE'?'/adhoc-advance-payment':'/adhoc-advance-payment';
    case "raise_pending_srn":
    url=type=='RAISE'?'/new-srn':'/new-srn';
    break;
  case 'failed_mailed_invoice':
    // Same page, but dashboard click will set state to open "failed" tab
    url=type=='RAISE'?'/mailed-invoice':'/mailed-invoice';
    break;
  case "raise_pending_srn":
    url=type=='RAISE'?'/new-srn':'/new-srn';
    break;
    case 'lob_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/primary-location-approval';
    break;
    case 'unit_type_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/unit-type-approval';
    break;
    case 'company_bank_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/company-bank-approval';
    break;
    case 'account_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/account-master-approval';
    break;
    case 'tds_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/tds-approval';
    break;
    case 'department_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/department-approval';
    break;
    case 'user_role_master_pending_to_be_updated':
      url=type=='RAISE'?'/settings':'/user-role-approval';
    break;
    case 'reason_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/reason-master-approval';
    break;
    case 'line_of_business_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/lob-master-approval';
    break;
  default:url='';
}
return url;
}
getPMPageUrl(data,type)
{
let url:any='';

switch(data.id)
{
  case 'pending_project':
    url=type=='RAISE'?'/project-master':'/project-master-approval';
  break;
  case 'recurring_invoice':
    url=type=='RAISE'?'/auto-generated-inv':'/recurring-inv-for-approval';
  break;
  case 'pending_task':
    url=type=='RAISE'?'/task-master':'/task-master-approval';
  break;
  case 'pending_timesheet':
    url=type=='RAISE'?'/time-sheet-v2':'/time-sheet-approval';
  break;
  case 'pending_expense':
    url=type=='RAISE'?'/expense-sheet-v2':'/expense-sheet-v2-approval';
  break;
  case 'pending_amc_task_approval':
    url=type=='RAISE'?'/amc-master':'/task-approvals';
  break;
  default:url='';
}
return url;
}
menuList:any=[];
getMenuList() {
   if (!this.isDashboardActive()) {
     return;
   }
   if (this.menuList.length<=0) {
    let id: any = "";
    if (this._localStorageService.getUserRole() == "administrator") {
      id = "0"
    }
    else {
      id = this._localStorageService.getEmpRoleId() == undefined || this._localStorageService.getEmpRoleId() == null ? "0" : this._localStorageService.getEmpRoleId();
    }
    let req:any={id:id}
  this.dashboardApi("User_Roles/ajax_menu_items_by_user_role", req).
    subscribe(
      data => {
        if (data.status) {
          let temp: any = [];
            temp = data.response;
          if (temp) {
            for (let i of temp) {
              if (i.submenu) {
                for (let j of i.submenu) {
                  if (j.aurl == "/bug-master") {
                    j.menuitemname = this.company_setup.custom_name_bug_master ? this.company_setup.custom_name_bug_master : "Bug Master";
                  }
                  if (j.aurl == "/my-bug-master") {
                    j.menuitemname = "My " + this.company_setup.custom_name_bug_master;
                  }
//                   if (this._localStorageService.getUserRole() != "administrator") {
//                   if ((j.aurl == "\/dashboard" || j.menuitemname== "Compliance Dashboard")) {
//                     // j.menuitemname = "Compliance Dashboard"
//                   // window.location.href=window.location.origin+'/compliance/#/dashboard';
//                 //  this.webService.redirectURL('/compliance/#/dashboard');
//                   // this.webService.redirectURL('http://localhost:4200/compliance/#/dashboard');
        
//                 }
// else{
//                     this.webService.redirectURL('/dashboard');
//                   }}
                }
              }
            }
          }
          this.menuList = temp;
          this.GetCompanySetUpData();
        }else{
          this.toasterService.pop('error', "Error", data.message);
          this.isRunning = false;
          this.dashboardLoader = false;
        }
      },
      error => {
        this.toasterService.pop('error', "Error", "Something Went Wrong");
        this.isRunning = false;
        this.dashboardLoader = false;
      }
    );
   }
}

IS_VAILID_URL(url)
{
  // let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

  let name:any=-'';
  let status:boolean=false;
  let array:any=[];
  array = this.menuList;
  if(array)
  {
    for(let i of array)
    {
      i.submenu=i.submenu?i.submenu:[]
      if(i.submenu)
      {
        let t:any=[];
        t=i.submenu.filter((v)=>{return v.aurl==url});
        if(t.length>0)
        {
          name=t[0].menuitemname?t[0].menuitemname:'';
          status=true;
        }
      }
    }
  }

  return status?status:false
}
isPoloarChart:boolean=false;
setChartType(type)
{
if(type=='polarArea')
{
  this.isPoloarChart=false;
  if(document.getElementById('activeChart')!=null)
  {
  // document.getElementById('activeChart').style.background=this.companyThemeBlockColor ? this.companyThemeBlockColor : "#035168";
  // document.getElementById('activeChart').style.color=this.CompanyThemetextColor ? this.CompanyThemetextColor : "#FFFFFF";
  }
}
else
{
  this.isPoloarChart=true;
}
this.pendingPOChartType=type;
}
getTimeSheetData(key)
{
  let list:any=JSON.parse(JSON.stringify(this.pendingProjectManagementTaskList));
  return list.some((v)=>{return v.key==key})?list.filter((v)=>{return v.key==key})[0]:{}
}
toggleCompanyData() {
  if (this.isRun) return; // Prevent the action while loading

  this.isDataVisible = !this.isDataVisible;  // Toggle the visibility

  if (this.isDataVisible) {
    // If we want to show the data, fetch it
    this.getViewData();
  } else {
    // If we want to hide the data, clear the companyGroupIds or handle it accordingly
    this.companyGroupIds = [];
    this.companyGroupList = [];
    this.filteredviewData  =[]
    this.isviewCompanyCardVisible =false;
  }
}
allCompanyTaskTitle:any='';
allCompanyTaskList:any= [];
allCompanyTaskCount:any = 0;
allCompanyTaskCountLastDays:any=0;
isAllCompanyCardVisible:boolean=false;
isviewCompanyCardVisible:boolean=false;

// getAllCompanyData():void {
//   if (this._localStorageService.getUserRole() == "vendor") {
//     return;
//   }
//   this.allCompanyTaskList=[];

//   this.allCompanyTaskCount = "";
//   let localCount1:any = 0;
//   let localDaysCount1:any=0;
//   let obj = {
//     "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
//     // "company_id": this._localStorageService.getEmpCompanyId(),
//     "company_id":"0",
//     "how_many_days_pending_in_dashboard":this.company_setup.how_many_days_pending_in_dashboard?this.company_setup.how_many_days_pending_in_dashboard:'5'
//   }
//   this.allCompanyTaskList=[];
//   this.isAllCompanyCardVisible=true;
//   this.isRunning=true;
//   this.dashboardApi("project/Timesheet/get_timesheet_chart_for_all_company", obj).
//     subscribe(
//       data => {
//         if (data.status) {
//           let temp:any=[];
//           data.response=data?data:{}
//           if(data.response)
//           {
//             for(let i in data.response)
//             {

//               let t:any=this.getTimeSheetData(i)
//               if(Object.keys(t).length>0)
//               {
//                 let toArray =  data.response[i].split("_");
//                 // console.log(toArray);
//                 toArray[0] = toArray[0] ? toArray[0] : 0;
//                 toArray[1] = toArray[1] ? toArray[1] : 0;
//                 t['count'] = toArray[1];
//                 t['total_count'] = toArray[0];

//                   temp.push({...t});
//                   // console.log(t)

//               }

//             }
//           }
//           this.allCompanyTaskList=[...temp]?[...temp]:[];
//           this.allCompanyTaskTitle=data.title?data.title:'All Companies Data';
//           console.log(this.allCompanyTaskList)
//           if(this.allCompanyTaskList){
//             for(let totalCount of this.allCompanyTaskList) {
//               // console.log(totalCount)
//               let title=totalCount.title;
//               if(title.indexOf(" For My Approval")!==-1)
//               {
//                 title=title.replace(" For My Approval", "");
//               }
//               if(title.indexOf(" for My Approval")!==-1)
//               {
//                 title=title.replace(" for My Approval", "");
//               }

//               totalCount.total_count = this.webService.convertNaN(totalCount.total_count) ? this.webService.convertNaN(totalCount.total_count) : 0;
//               totalCount.count = this.webService.convertNaN(totalCount.count) ? this.webService.convertNaN(totalCount.count) : 0;

//               if( totalCount.total_count !=""){
//                 if(this.isPendingCardVisibleForPM(totalCount.key)||this.isPendingCardVisible(totalCount.key)){
//                   localCount1 += parseFloat(totalCount.total_count);
//                 }
//               }
//               if( totalCount.count !=""){
//                 if(this.isPendingCardVisibleForPM(totalCount.key)||this.isPendingCardVisible(totalCount.key)){
//                   localDaysCount1 += parseFloat(totalCount.count);
//                 }
//               }
//             }
//           }
//           this.allCompanyTaskCount = localCount1 ? localCount1 : 0;
//           this.allCompanyTaskCountLastDays= localDaysCount1 ? localDaysCount1 : 0;
//          }
//          else
//          {
//           this.toasterService.pop('error', "Error", data.message);

//          }
//          this.isRunning=false;

//       },
//       error => {
//         this.toasterService.pop('error', "Error", "Something Went Wrong");
// this.isRunning=false;
//       }
//     );
// }
allCompanyData:any = [];
getAllCompanyData():void {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    return;
  }
  this.allCompanyTaskList=[];

  this.allCompanyTaskCount = "";
  let localCount1:any = 0;
  let localDaysCount1:any=0;
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "current_company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : "0",
    "company_id": "0",
    "how_many_days_pending_in_dashboard":this.company_setup.how_many_days_pending_in_dashboard?this.company_setup.how_many_days_pending_in_dashboard:'0',
    "company_ids": this.companyGroupIds ? this.companyGroupIds : []
  }
  this.allCompanyTaskList=[];
  this.isAllCompanyCardVisible=true;
  this.isRunning=true;
  this.dashboardApi("project/Timesheet/get_pie_chart_for_all_company", obj).
    subscribe(
      data => {
        if (data.status) {
          let temp:any=[];
          let tempArray = [];
          this.allCompanyData = data.response ? data.response : [];
          tempArray = data.response ? data.response : [];
          // this.allCompanyData = this.filterchartAllCompanyData(this.allCompanyData);
          if(tempArray){
            for(let d of tempArray){
              d.total_count = 0;
              d.count = 0;
              if(d.items){
                for(let x of d.items){
                  x.total_count = x.total_count ? this.webService.convertNaN(x.total_count) : 0;
                  x.count = this.webService.convertNaN(x.count) ? this.webService.convertNaN(x.count) : 0;
                  if(x.total_count != ""){
                    if(this.isPendingCardVisibleForPM(x.key)||this.isPendingCardVisible(x.key)){
                      d.total_count = +d.total_count + +x.total_count
                    }
                  }
                  if(x.count != ""){
                    if(this.isPendingCardVisibleForPM(x.key)||this.isPendingCardVisible(x.key)){
                      d.count = +d.count + +x.count
                    }
                  }
                }
              }
              localCount1 = +localCount1 + +d.total_count
              localDaysCount1= +localDaysCount1 + d.count

              // d.total_count = d.items ? d.items.reduce((pre,next)=>{return +pre.total_count + +next.total_count}): 0
              // d.count = d.items ? d.items.reduce((pre,next)=>{return +pre.count + +next.count}): 0
            }
          }
          this.allCompanyTaskCount = localCount1 ? localCount1 : 0;
          this.allCompanyTaskCountLastDays= localDaysCount1 ? localDaysCount1 : 0;
          this.allCompanyData = this.filterchartAllCompanyData(tempArray);
         }
         else
         {
          this.toasterService.pop('error', "Error", data.message);

         }
         this.isRunning=false;

      },
      error => {
        this.toasterService.pop('error', "Error", "Something Went Wrong");
        this.isRunning=false;
      },
    );
}


filterchartAllCompanyData(data: any) {
  let list: any = [];
  for (let x of data) {
    let temp = { title_with_count:'',title: "", label: [], data: [], total: 0, pieChartType: 'pie', lineChartLegend: true , key:x.key,temp_company_title:"",tempItems:[],backgroundColor:[],"company_title":[],tempLabel:[]};
    temp.title = x.title;
    temp.key = x.key;
    temp.pieChartType = temp.pieChartType ? temp.pieChartType : 'pie';
    temp.total = 0;
    temp.tempItems = x.items ? x.items.map((d)=>({count_title : d.count_title ? d.count_title.replace(/\s+/g, '').toLowerCase() : "","company_id": d.company_id ? d.company_id : ""})) : [];
    for (let y of x.items) {
      temp.backgroundColor.push(y.color)
      temp.company_title.push(y.company_title);
      // y.temp_company_title = `${y.count}-${y.total_count} ${y.company_title}`
      temp.total = temp.total + parseFloat(y.count);
      if (parseFloat(y.count) > 0) {
        temp.label.push(y.count_title);
        temp.tempLabel.push({"count_title" : y.count_title,"company_title": y.company_title})
      }
      else {
        //temp.label.push(y.count_title);
        temp.label.push(y.count_title);
        temp.tempLabel.push({"count_title" : y.count_title,"company_title": y.company_title})

      }
      temp.data.push(y.count);
    }
    temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';
    temp.title_with_count= temp.title +"("+temp.total+")"
    list.push(temp);
  }
  return list;
}

openPendingInvoicesPopupIfInvoiceApproval(titleWithCount: any): void {
  if(this.company_setup.enable_all_company_data_approval != '1'){
    return
  }
  console.log('openPendingInvoicesPopupIfInvoiceApproval here',titleWithCount)
  const title = (titleWithCount || '').toString();
  if (title.toLowerCase().indexOf('invoice for my approval') !== -1) {
    if (!this.companyGroupIds || this.companyGroupIds.length <= 0) {
      this.getMultiCompanyIds();
    }
    this.showPendingInvoicesPopup = true;
  }
}

closePendingInvoicesPopup(): void {
  this.showPendingInvoicesPopup = false;
}
companyGroupIds:any = [];
companyGroupList:any = [];
getMultiCompanyIds() {
  if (!this.isDashboardActive()) {
    return;
  }
  let obj = {
    "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : "0",
  }
  this.dashboardApi("/Companies/get_group_company_ids", obj).subscribe((data)=>{
    if(data.status){
      let TmpIds = data.response ? data.response : [];
      this.companyGroupList = TmpIds ? TmpIds : [];
      this.companyGroupIds = TmpIds ? TmpIds.map(d => d.company_id): [];
      this.getAllCompanyData();
    }
  })
}
cardDataList: any = [];
getCardData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.continueDashboardCounterChain(onComplete);
    return;
  }
  this.cardDataList = [];
  let localCount: any = 0;
  let localDaysCount: any = 0;
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
    "how_many_days_pending_in_dashboard": this.company_setup.how_many_days_pending_in_dashboard ? this.company_setup.how_many_days_pending_in_dashboard : '5'
  }
  // if(1==1) {
  //   return false;
  // }
  this.cardDataList = [];

  const proceedAfterCardData = () => {
    if (this.company_setup.hide_dashboard_counter != '1') {
      this.proceedDashboardCounterNext(onComplete, () => this.getInvoiceAgeingData());
    } else {
      this.continueDashboardCounterChain(onComplete);
    }
  };

  this.runDashboardCounterHttp(
    "/User_Roles/showCardDetails",
    obj,
    onComplete ? () => proceedAfterCardData() : undefined,
    (data) => {
        if (data.status) {
          let temp: any = [];
          data.response = typeof data.response == 'object' ? ([data.response ? data.response : {}]) : data.response
          if (data.response) {
            for (let i of data.response) {
              // console.log(i)
              this.vendorranking=i.vendor_ranking
              this.topProducts=i.top_products

              console.log( this.topProducts ,' this.topProducts')

              if (i.items.length > 0) {
                for (let j of i.items) {
                  j.key = j.key == 'raise_pending_recurring_invoices' ? 'recurring_invoice' : j.key
                  temp.push(j);
                }
              }
              if (this.webService.IS_VAILID_URL('/card-menu')) {
                this.getRanking(i.vendor_ranking ? i.vendor_ranking : [])
              }
              if (this.webService.IS_VAILID_URL('/card-menu')) {
                this.getTopProducts(i.top_products ? i.top_products : [])
              }
            }
          }
          this.cardDataList = temp ? temp : [];
          if (this.cardDataList) {
            for (let totalCount of this.cardDataList) {
              totalCount.isVisible = true
              if ((totalCount.key == 'product_approved')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              if ((totalCount.key == 'pending_po')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              if ((totalCount.key == 'total_po_value')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              if ((totalCount.key == 'vendors_profile_update')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              if ((totalCount.key == 'vendors_active')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }

              if ((totalCount.key == 'vendors_logged_in')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              // console.log(totalCount)
              let title = totalCount.title;
              if (title.indexOf(" For My Approval") !== -1) {
                title = title.replace(" For My Approval", "");;
              }
              if (title.indexOf(" for My Approval") !== -1) {
                title = title.replace(" for My Approval", "");;
              }

              totalCount.total_count = this.webService.convertNaN(totalCount.total_count) ? parseInt(this.webService.convertNaN(totalCount.total_count)) : 0;
              totalCount.count = this.webService.convertNaN(totalCount.count) ? parseInt(this.webService.convertNaN(totalCount.count)) : 0;
            }
          }
          this.cardDataList = this.cardDataList.filter((v) => { return v.isVisible })
        }
      },
      () => {
      }
    );
}
colors?: any = ['#5fb2c6', '#53a759', '#e88b44', '#e23f3d']
chartType: any = {

  'pie': {
    type: 'pie', colors: [], options: {
      legend: {
        position: 'right',
        orient: 'vertical',
        display: true
      },
      plugins: {
        datalabels: {
          display: false,
        }
      }
  }
  }
}

getTopProducts(responseData: any) {
  if (responseData) {
    let colors=[]
    let data=[]
    let topProduct={data:[],labels:[],lineChartColors:[],fullList:[]}
    for (let k of responseData) {
      let p_name = k.product_name + "(" + k.productcode + ")"
      let color=k.color ? k.color : '#035168'
      var str = p_name;
      if(str.length > 4) str = str.substring(0,4)+"...";
      topProduct.labels.push(str);
     data.push(parseFloat(this.webService.convertNaN((k.amount))))
      colors.push(color)
      topProduct.fullList.push({lable:p_name,amount:k.amount_in_k})
    }
    topProduct.data.push(
      {
        type: 'bar',
        label: '',
        data: data,
        fill: false,
        borderColor: '',
        pointStyle: 'spline',
        pointBorderWidth: 7,
        display: true,
        backgroundColor: '',
      }
    )
    topProduct.lineChartColors = [{ backgroundColor: colors }];
    let icon=this.webService.getCurrencyIconString(this.company_setup.currency_icon)
    this.topProduct= {
      labels: topProduct.labels?topProduct.labels:[],
      data: topProduct.data?topProduct.data:[],
      barChartType: 'bar',
      colors: ['red', 'bule', 'red', 'bule', 'red', 'bule',],
      barlineChartLegend: false,
      title: '',
      ChartLegend: true,
      lineChartColors: topProduct.lineChartColors,
      barChartPlugins: [],
      options: {
        tooltips: {
          displayColors:false,
          callbacks: {
            title: function(tooltipItem, data) {
              return '';
            },
            label: function(tooltipItem, data) {
                  //your logic...
                    let d:any=topProduct.fullList[tooltipItem.index||0]?topProduct.fullList[tooltipItem.index||0]:{}
                    tooltipItem.label=d.lable?d.lable:''
                    tooltipItem.xLabel=d.lable?d.lable:''
                   var label= d.lable+"\n"+ icon+" "+d.amount
                   return label;

                },
              }
        },

        layout: {
          padding: {
              left: 0,
              right: 0,
              top: 30,
              bottom: 0
          }
      },
        maintainAspectRatio: true,
scaleShowVerticalLines: false,
scaleShowValues: true,
scaleValuePaddingX: 10,
scaleValuePaddingY: 10,
        responsive: true,
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter:  (value, context)=> {
              return topProduct.fullList[context.dataIndex] ? topProduct.fullList[context.dataIndex].amount : value;
             }
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            },
            ticks: {
            // callback: function (value, index, values) {
            //   // console.log(value)
            //   // console.log(index)
            //   // console.log(values)
            //   return value + icon;
            // }
          }
          }],
          yAxes: [{
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            }
            ,
            ticks: {
              // padding: 25,
              beginAtZero: true,
              maxTicksLimit: 5,
              // Create scientific notation labels
              callback: function (value, index, values) {
                // console.log(value)
                // console.log(index)
                // console.log(values)
                // console.log(topProduct.fullList)
              function formatToK(number) {
                  if (number >= 1000) {
                    return parseInt((number / 1000).toFixed(0)).toLocaleString() + 'K';
                  } else {
                    return number
                  }
                }
                return formatToK(value) + icon;
              }
            }
          }]
        }
      }
    }
  }
}
responseData1:any=[]
getRanking(responseData: any) {

  this.colors = []
  this.responseData1=responseData?responseData:[]
  let d: any = { items: [] }
  if (this.responseData1) {
    for (let i of this.responseData1) {
      i.title = i.category ? i.category : ''
      i.title = i.title + " (" + (i.count ? i.count : 0) + ")"
      d['category'] = i.category ? i.category : ''
      d['title'] = i.title ? i.title : ''
      d['color'] = i.color ? i.color : ''
      d['count'] = i.count ? i.count : 0
      this.colors.push(i.color)
      d.items.push(i)
    }
    this.chartType.pie.colors = [{ backgroundColor: this.colors }];
  }
  let list = this.filterRankingData([d]);
  if (list.length > 0) {
    console.log(list)
    this.filteredRankingData = [list[0]]
  }


}

filterRankingData(data: any) {
  let list: any = [];
  for (let x of data) {
    let temp = { title: "", label: [], data: [] };
    temp.title = x.title;
    for (let y of x.items) {
      temp.label.push(y.title);
      temp.data.push(y.count);
    }
    list.push(temp);
  }
  return list;
}
public chartClicked(e: any): void {
  if (e.active.length > 0) {
    const chart = e.active[0]._chart;
    const activePoints = chart.getElementAtEvent(e.event);
    if (activePoints.length > 0) {
      // get the internal index of slice in pie chart
      const clickedElementIndex = activePoints[0]._index;
      const label = chart.data.labels[clickedElementIndex];
      // get value by index
      const value = chart.data.datasets[0].data[clickedElementIndex];
      // this.navigateUrl(label,value);
      let key=label
      let category=label?label:''
      console.log(label)
      // console.log(this.responseData)
      let t=this.responseData1.filter((v)=>{return v.title==(key?key:'')}).length>0?this.responseData1.filter((v)=>{return v.title==(key?key:'')})[0]:{}
      if(Object.keys(t).length>0)
      {
      category=t.range?t.range:''
        console.log(t)
        localStorage.setItem('vendor_ranking_category',category);
        let redirectUrl = '/#';
        let origin = window.location.origin;
        redirectUrl = origin + '/master' + redirectUrl + '/vendors';
        // console.log(redirectUrl)
        window.location.href=redirectUrl
      }
    }
  }
}

navigateData(key)
{
  if(key=='product_approved')
  {
localStorage.setItem("dashboardAction", this.webService.set('approved_product','dashboardAction'));
let redirectUrl = '/#';
let origin = window.location.origin;
redirectUrl = origin + '/master' + redirectUrl + '/products';
// console.log(redirectUrl)
window.location.href=redirectUrl
  }
  if(key=='pending_po')
  {
   // console.log('approval_pending_po')
//localStorage.setItem("dashboardAction", this.webService.set('approval_pending_po','dashboardAction'));
//this.webService.redirectURL('po-approval')
  }
  if(key=='total_po_value')
  {
//localStorage.setItem("dashboardAction", this.webService.set('all_po','dashboardAction'));
//this.webService.redirectURL('poapproval-summary')
  }
  if(key=='vendors_profile_update')
  {
localStorage.setItem("dashboardAction", this.webService.set('vendor_profile_updated_id','dashboardActionVendorProfile'));
let redirectUrl = '/#';
let origin = window.location.origin;
redirectUrl = origin + '/master' + redirectUrl + '/vendors';
// console.log(redirectUrl)
window.location.href=redirectUrl
  }
  if(key=='vendors_active')
  {
    localStorage.setItem("dashboardAction", this.webService.set('is_vendor_portal_active','dashboardAction'));
    let redirectUrl = '/#';
    let origin = window.location.origin;
    redirectUrl = origin + '/master' + redirectUrl + '/vendors';
    // console.log(redirectUrl)
    window.location.href=redirectUrl
  }

  if(key=='vendors_logged_in')
  {
    localStorage.setItem("dashboardAction", this.webService.set('logged_vendor'));
    let redirectUrl = '/#';
    let origin = window.location.origin;
    redirectUrl = origin + '/report' + redirectUrl + '/vendor-activity';
    // console.log(redirectUrl)
    window.location.href=redirectUrl
  }
}
public chartHovered(e: any): void {
  console.log(e)
}
chartHoveredData(tooltipItem,data)
{
  return tooltipItem.index||0
}
closeSupportPopup() {
  this.showSupportPopupFlag = false;
  this.popupService.open(false);
}
ngOnDestroy() {
  this.popupService.open(false);
  this.dashboardLoader = false;
  this.isRunning = false;
  this.resetDashboardCounterLoad();
  this.destroy$.next();
  this.destroy$.complete();
}

getTallyIntegrationData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  // Hit this API only when ajax_menu_items_by_user_role contains aurl: "/card-menu"
  if (!this.IS_VAILID_URL('/card-menu')) {
    this.tallyIntegrationData = [];
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
    how_many_days_pending_in_dashboard: (this.company_setup && this.company_setup.how_many_days_pending_in_dashboard)
      ? this.company_setup.how_many_days_pending_in_dashboard
      : '5'
  };

  this.tallyIntegrationData = [];
  this.runDashboardCounterHttp(
    "/User_Roles/ajax_dashboard_tally_cards_counter",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (!data || !data.status) {
        this.tallyIntegrationData = [];
        return;
      }

      const responseArr = typeof data.response === 'object'
        ? ([data.response ? data.response : {}])
        : (data.response || []);

      const temp: any[] = [];
      for (const i of responseArr) {
        if (i && i.items && i.items.length > 0) {
          for (const j of i.items) {
            temp.push(j);
          }
        }
      }

      this.tallyIntegrationData = temp;
    },
    () => {
      this.tallyIntegrationData = [];
    }
  );
}

myAmcTaskCardsTitle: any = 'My AMC Task Cards';
myAmcTaskCards: any[] = [];
myAmcTaskCardsTotal: any = 0;
getMyAmcTaskCards(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.myAmcTaskCards = [];
    this.myAmcTaskCardsTotal = 0;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  // Permission guard: route should exist in menu
  if (!this.IS_VAILID_URL('/my-amc-task')) {
    this.myAmcTaskCards = [];
    this.myAmcTaskCardsTotal = 0;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
  };

  this.myAmcTaskCards = [];
  this.myAmcTaskCardsTotal = 0;

  this.runDashboardCounterHttp(
    "Amc_dashboard/ajax_my_cards",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (!data || !data.status) {
        this.myAmcTaskCards = [];
        this.myAmcTaskCardsTotal = 0;
        return;
      }

      const getNum = (v: any) => {
        const n = this.webService.convertNaN(v);
        return n ? parseInt(n, 10) : 0;
      };

      // API response: { status, message, data: { cards: { my_today:{total}, my_overdue:{total}, my_this_week:{total}, my_next_week:{total} } } }
      const cards: any = data.data && data.data.cards ? data.data.cards : null;
      if (!cards) {
        this.myAmcTaskCards = [];
        this.myAmcTaskCardsTotal = 0;
        return;
      }

      const todayTotal = getNum(cards.my_today && cards.my_today.total != null ? cards.my_today.total : 0);
      const overdueTotal = getNum(cards.my_overdue && cards.my_overdue.total != null ? cards.my_overdue.total : 0);
      const thisWeekTotal = getNum(cards.my_this_week && cards.my_this_week.total != null ? cards.my_this_week.total : 0);
      const nextWeekTotal = getNum(cards.my_next_week && cards.my_next_week.total != null ? cards.my_next_week.total : 0);

      this.myAmcTaskCardsTitle = data.message ? data.message : 'My AMC Task Cards';
      this.myAmcTaskCards = [];
      this.myAmcTaskCardsTotal = 0;
      if (this.isPendingCardVisible('my_todays_tasks')) {
        this.myAmcTaskCards.push({ key: 'my_amc_today_tasks', title: "My Today's Tasks", count: todayTotal, color: "#f1894f" });
        this.myAmcTaskCardsTotal += todayTotal;
      }
      if (this.isPendingCardVisible('my_overdue_tasks')) {
        this.myAmcTaskCards.push({ key: 'my_amc_overdue_tasks', title: "My Overdue Tasks", count: overdueTotal, color: "#ec343c" });
        this.myAmcTaskCardsTotal += overdueTotal;
      }
      if (this.isPendingCardVisible('my_this_week_tasks')) {
        this.myAmcTaskCards.push({ key: 'my_amc_this_week_tasks', title: "My This Week Tasks", count: thisWeekTotal, color: "#4caf62" });
        this.myAmcTaskCardsTotal += thisWeekTotal;
      }
      if (this.isPendingCardVisible('my_next_week_tasks')) {
        this.myAmcTaskCards.push({ key: 'my_amc_next_week_tasks', title: "My Next Week Tasks", count: nextWeekTotal, color: "#4cb2c4" });
        this.myAmcTaskCardsTotal += nextWeekTotal;
      }
    },
    () => {
      this.myAmcTaskCards = [];
      this.myAmcTaskCardsTotal = 0;
    }
  );
}

vendorDetailsCard: any = null;
riskyVendorIds: any[] = [];
riskyVendorThreshold: any = '60';

getVendorDetailsCard() {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.vendorDetailsCard = null;
    this.riskyVendorIds = [];
    return;
  }
  if (this.company_setup.is_risky_vendors_visible_in_dashboard != '1') {
    this.vendorDetailsCard = null;
    this.riskyVendorIds = [];
    return;
  }
  if (!this.IS_VAILID_URL('/card-menu')) {
    this.vendorDetailsCard = null;
    this.riskyVendorIds = [];
    return;
  }

  this.fetchVendorRatingDashboard((data) => {
    if (!data || !data.status || !data.data) {
      this.vendorDetailsCard = null;
      this.riskyVendorIds = [];
      return;
    }

    const getNum = (v: any) => {
      const n = this.webService.convertNaN(v);
      const parsed = parseInt(n, 10);
      return isNaN(parsed) ? 0 : parsed;
    };

    const responseData = data.data;
    const riskyVendorsCard = responseData.risky_vendors || {};
    const vendorList = responseData.data && Array.isArray(responseData.data) ? responseData.data : [];

    this.riskyVendorIds = vendorList
      .filter((v: any) => v.is_risky === true)
      .map((v: any) => v.vendor_id);

    this.riskyVendorThreshold = responseData.threshold != null ? String(responseData.threshold) : '60';

    const count = getNum(
      riskyVendorsCard.count != null
        ? riskyVendorsCard.count
        : responseData.risky_vendor_count
    );

    if (count <= 0) {
      this.vendorDetailsCard = null;
      return;
    }

    this.vendorDetailsCard = {
      key: riskyVendorsCard.key || 'risky_vendors',
      title: riskyVendorsCard.title || 'Risky Vendor',
      count: count,
      color: riskyVendorsCard.color || '#FF6B6B',
      icon: riskyVendorsCard.icon || 'fa fa-thumbs-up'
    };
  });
}

private fetchVendorRatingDashboard(callback: (data: any) => void) {
  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
  };

  this.dashboardApi("vendor_rating/ajax_dashboard", obj).subscribe(
    (data) => callback(data),
    () => callback(null)
  );
}

navigateToVendorDetails() {
  const cardKey = this.vendorDetailsCard && this.vendorDetailsCard.key ? this.vendorDetailsCard.key : 'risky_vendors';
  localStorage.setItem("dashboardAction", this.webService.set(cardKey, 'dashboardAction'));
  localStorage.setItem('dashboard_risky_vendor_ids', JSON.stringify(this.riskyVendorIds || []));
  localStorage.setItem('dashboard_risky_vendor_threshold', this.riskyVendorThreshold || '60');
  let redirectUrl = '/#';
  let origin = window.location.origin;
  redirectUrl = origin + '/master' + redirectUrl + '/vendors';
  window.location.href = redirectUrl;
}

allAmcTaskCardsTitle: any = 'All AMC Task Cards';
allAmcTaskCards: any[] = [];
allAmcTaskCardsTotal: any = 0;
getAllAmcTaskCards(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.allAmcTaskCards = [];
    this.allAmcTaskCardsTotal = 0;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  // Permission guard: route should exist in menu
  if (!this.IS_VAILID_URL('/all-amc-tasks')) {
    this.allAmcTaskCards = [];
    this.allAmcTaskCardsTotal = 0;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
  };

  this.allAmcTaskCards = [];
  this.allAmcTaskCardsTotal = 0;

  this.runDashboardCounterHttp(
    "Amc_dashboard/ajax_all_cards",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (!data || !data.status) {
        this.allAmcTaskCards = [];
        this.allAmcTaskCardsTotal = 0;
        return;
      }

      const getNum = (v: any) => {
        const n = this.webService.convertNaN(v);
        return n ? parseInt(n, 10) : 0;
      };

      const cards: any = data.data && data.data.cards ? data.data.cards : null;
      if (!cards) {
        this.allAmcTaskCards = [];
        this.allAmcTaskCardsTotal = 0;
        return;
      }

      const todayTotal = getNum(cards.all_today && cards.all_today.total != null ? cards.all_today.total : 0);
      const overdueTotal = getNum(cards.all_overdue && cards.all_overdue.total != null ? cards.all_overdue.total : 0);
      const thisWeekTotal = getNum(cards.all_this_week && cards.all_this_week.total != null ? cards.all_this_week.total : 0);
      const nextWeekTotal = getNum(cards.all_next_week && cards.all_next_week.total != null ? cards.all_next_week.total : 0);

      this.allAmcTaskCardsTitle = data.message ? data.message : 'All AMC Task Cards';
      this.allAmcTaskCards = [];
      this.allAmcTaskCardsTotal = 0;
      if (this.isPendingCardVisible('all_todays_tasks')) {
        this.allAmcTaskCards.push({ key: 'all_amc_today_tasks', title: "All Today's Tasks", count: todayTotal, color: "#f1894f" });
        this.allAmcTaskCardsTotal += todayTotal;
      }
      if (this.isPendingCardVisible('all_overdue_tasks')) {
        this.allAmcTaskCards.push({ key: 'all_amc_overdue_tasks', title: "All Overdue Tasks", count: overdueTotal, color: "#ec343c" });
        this.allAmcTaskCardsTotal += overdueTotal;
      }
      if (this.isPendingCardVisible('all_this_week_tasks')) {
        this.allAmcTaskCards.push({ key: 'all_amc_this_week_tasks', title: "All This Week Tasks", count: thisWeekTotal, color: "#4caf62" });
        this.allAmcTaskCardsTotal += thisWeekTotal;
      }
      if (this.isPendingCardVisible('all_next_week_tasks')) {
        this.allAmcTaskCards.push({ key: 'all_amc_next_week_tasks', title: "All Next Week Tasks", count: nextWeekTotal, color: "#4cb2c4" });
        this.allAmcTaskCardsTotal += nextWeekTotal;
      }
    },
    () => {
      this.allAmcTaskCards = [];
      this.allAmcTaskCardsTotal = 0;
    }
  );
}

amcOverdueAgeingLoader: boolean = false;
amcOverdueAgeingChart: any = null; // scope: my
amcOverdueAgeingAllLoader: boolean = false;
amcOverdueAgeingAllChart: any = null; // scope: all
// Keep employee filter only in memory (default empty).
amcOverdueAgeingAllEmployeeId: string = '';
amcOverdueAgeingAllEmployeeName: string = '';

formatAmcOverdueAgeingChart(apiResponse: any, scope: 'my' | 'all') {
  const bucketColors: { [bucketName: string]: string } = {
    '0_3': '#59A14F',
    '4_7': '#4E79A7',
    '8_15': '#F28E2B',
    'gt_15': '#E15759',
    'gt_30': '#A05195',
  };
  const d = apiResponse && apiResponse.data ? apiResponse.data : null;
  const buckets = d && d.buckets ? d.buckets : null;
  // Show exactly the name sent by API (data.title, chart_title, or other common keys); fallback to message / default
  let titleBase = '';
  if (d) {
    const rawName = d.title || d.chart_title || d.chart_name || d.name;
    if (rawName && String(rawName).trim()) {
      titleBase = String(rawName).trim();
    }
  }
  if (!titleBase && apiResponse && apiResponse.message) {
    titleBase = String(apiResponse.message);
  }
  if (!titleBase) {
    titleBase = scope === 'all' ? 'All AMC overdue ageing' : 'AMC overdue ageing';
  }

  const getNum = (v: any) => {
    const n = this.webService.convertNaN(v);
    return n ? parseInt(n, 10) : 0;
  };

  if (!buckets) {
    return null;
  }

  const list = [
    { key: '0_3', label: '0–3 days', count: getNum(buckets['0_3'] && buckets['0_3'].total != null ? buckets['0_3'].total : 0) },
    { key: '4_7', label: '4–7 days', count: getNum(buckets['4_7'] && buckets['4_7'].total != null ? buckets['4_7'].total : 0) },
    { key: '8_15', label: '8–15 days', count: getNum(buckets['8_15'] && buckets['8_15'].total != null ? buckets['8_15'].total : 0) },
    { key: 'gt_15', label: 'More than 15 days', count: getNum(buckets['gt_15'] && buckets['gt_15'].total != null ? buckets['gt_15'].total : 0) },
    { key: 'gt_30', label: 'More than 30 days', count: getNum(buckets['gt_30'] && buckets['gt_30'].total != null ? buckets['gt_30'].total : 0) },
  ];

  let total = 0;
  const labels: any[] = [];
  const data: any[] = [];
  const colors: any[] = [];
  const items: any[] = [];

  for (const x of list) {
    total += x.count;
    const labelText = x.label + ' (' + x.count + ')';
    labels.push(labelText);
    data.push(x.count);
    colors.push(bucketColors[x.key] ? bucketColors[x.key] : '#4E79A7');
    items.push({ bucket: x.key, label: x.label, count: x.count, labelText: labelText });
  }

  // title = API name only; template shows total as (n) next to it
  return {
    title: titleBase,
    label: labels,
    data: data,
    colors: colors,
    total: total,
    pieChartType: 'pie',
    lineChartLegend: true,
    key: scope === 'all' ? 'amc_overdue_ageing_all' : 'amc_overdue_ageing',
    items: items
  };
}

getAmcOverdueAgeingChart(scope: 'my' | 'all', onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    if (scope === 'all') {
      this.amcOverdueAgeingAllChart = null;
    } else {
      this.amcOverdueAgeingChart = null;
    }
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  if (scope === 'all') {
    this.amcOverdueAgeingAllLoader = true;
  } else {
    this.amcOverdueAgeingLoader = true;
  }
  // Send employee_id only after user selects an employee.
  let employee_id: any = '';
  if (scope === 'all') {
    employee_id = this.amcOverdueAgeingAllEmployeeId ? this.amcOverdueAgeingAllEmployeeId : '';
  }
  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
    scope: scope,
    employee_id: employee_id
  };

  this.runDashboardCounterHttp(
    "Amc_dashboard/ajax_ageing_chart",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (scope === 'all') {
        this.amcOverdueAgeingAllLoader = false;
        if (data && data.status) {
          this.amcOverdueAgeingAllChart = this.formatAmcOverdueAgeingChart(data, 'all');
          if (this.amcOverdueAgeingAllChart) {
            this.amcOverdueAgeingAllChart.employee_id = this.amcOverdueAgeingAllEmployeeId;
            this.amcOverdueAgeingAllChart.employee_name = this.amcOverdueAgeingAllEmployeeName;
          }
        } else {
          this.amcOverdueAgeingAllChart = null;
        }
      } else {
        this.amcOverdueAgeingLoader = false;
        if (data && data.status) {
          this.amcOverdueAgeingChart = this.formatAmcOverdueAgeingChart(data, 'my');
        } else {
          this.amcOverdueAgeingChart = null;
        }
      }
    },
    () => {
      if (scope === 'all') {
        this.amcOverdueAgeingAllLoader = false;
        this.amcOverdueAgeingAllChart = null;
      } else {
        this.amcOverdueAgeingLoader = false;
        this.amcOverdueAgeingChart = null;
      }
    }
  );
}

onAmcOverdueAgeingAllEmployeeSelected(event: any) {
  this.amcOverdueAgeingAllEmployeeId = event && event.id ? String(event.id) : '';
  this.amcOverdueAgeingAllEmployeeName = event && event.name ? String(event.name) : '';
  this.getAmcOverdueAgeingChart('all');
}

navigateFailedIntegrationByUrl(key) {
  let url = "";
  let project = '';
  let dashboardAction = "";
  switch (key) {
    case "sapb1_failed_integrations":
      url = "/all-approved-invoices";
      project = 'operation';
      dashboardAction = "sapb1_failed_integrations";
      break;
    default:
      url = "";
  }

  localStorage.setItem("dashboardAction", this.eesdesService.set(dashboardAction));
  if (url != '' && url != undefined) {
    let redirectUrl = '/#';
    let origin = window.location.origin;
    if (project == 'master') {
      redirectUrl = origin + '/master' + redirectUrl + url;
    } else if (project == 'report') {
      redirectUrl = origin + '/report' + redirectUrl + url;
    } else if (project == 'mapping') {
      redirectUrl = origin + '/mapping' + redirectUrl + url;
    } else if (project == 'finance') {
      redirectUrl = origin + '/finance' + redirectUrl + url;
    } else if (project == 'project_management') {
      redirectUrl = origin + '/project_management' + redirectUrl + url;
    } else if (project == 'help_desk') {
      redirectUrl = origin + '/help_desk' + redirectUrl + url;
    } else {
      if (url == '#' || !url) return;
      this.webService.redirectURL(url);
      return;
    }
    window.location.href = redirectUrl;
  }
}

getFailedIntegrationData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }

  const sapB1Enabled = this.company_setup && this.company_setup.sap_b1_api_enable == '1';
  const sapEnabled = this.company_setup && this.company_setup.enable_sap_integration == '1';
  const isBothSapTogglesDisabled = !sapB1Enabled && !sapEnabled;

  if (isBothSapTogglesDisabled) {
    this.failedIntegrationData = [];
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
    how_many_days_pending_in_dashboard: (this.company_setup && this.company_setup.how_many_days_pending_in_dashboard)
      ? this.company_setup.how_many_days_pending_in_dashboard
      : '5'
  };

  this.failedIntegrationData = [];
  this.runDashboardCounterHttp(
    "/User_Roles/ajax_dashboard_failed_integrations_cards_counter",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (!data || !data.status) {
        this.failedIntegrationData = [];
        return;
      }

      const responseArr = typeof data.response === 'object' ? ([data.response ? data.response : {}]) : (data.response || []);
      const temp: any[] = [];
      for (const i of responseArr) {
        if (i && i.items && i.items.length > 0) {
          for (const j of i.items) {
            let isVisible = true;
            if (!j || !j.key) {
              isVisible = false;
            }
            if (j.key === 'sapb1_failed_integrations') {
              isVisible = sapB1Enabled;
            }
            if (j.key === 'sap_failed_integrations') {
              isVisible = sapEnabled;
            }
            if(isVisible) {
              temp.push(j);
            }
          }
        }
      } 
      this.failedIntegrationData = temp;
    },
    () => {
      this.failedIntegrationData = [];
    }
  );
}
}



// WEBPACK FOOTER //
// /codebuild/output/src198490057/src/src/app/pages/dashboard/dashboard.component.ts